export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type GetLaborExchangeTemplate_HeaderQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetLaborExchangeTemplate_HeaderQuery = { __typename?: 'Query', getLaborExchangeTemplate?: { __typename?: 'LaborExchangeTemplate', header: { __typename?: 'LaborExchangeTemplateHeader', logo?: { __typename?: 'LaborExchangeTemplateHeaderLogo', source?: string | null, sourceHeader?: string | null } | null } } | null };

export type LeavePostulationMutationVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type LeavePostulationMutation = { __typename?: 'Mutation', leavePostulation: { __typename?: 'SuccessResponse', success?: boolean | null } };

export type GetCandidate_Info_UserQueryVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type GetCandidate_Info_UserQuery = { __typename?: 'Query', candidate: { __typename?: 'Candidate', _id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, fullName?: string | null, photo?: string | null } };

export type GetUser_HeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUser_HeaderQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', _id: string, email: string, firstName?: string | null, lastName?: string | null, photo?: string | null } | null };

export type Logout_HeaderMutationVariables = Exact<{ [key: string]: never; }>;


export type Logout_HeaderMutation = { __typename?: 'Mutation', logout?: { __typename?: 'Response', success: boolean, data?: any | null } | null };

export type GetUser_SupportLiveChatQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUser_SupportLiveChatQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', _id: string, email: string, firstName?: string | null, lastName?: string | null, photo?: string | null } | null };

export type BranchOfficeCandidateFragmentFragment = { __typename?: 'Candidate', _id: string, branchOffices?: Array<{ __typename?: 'BranchOfficeCandidate', branchOfficeId: string, available: boolean, distance?: number | null, preview: { __typename?: 'PreviewBranchOfficeCandidate', available: boolean }, branchOffice?: { __typename?: 'BranchOffice', _id: string, name: string, district?: string | null, province?: string | null, region?: string | null, department?: string | null, geometry: { __typename?: 'GeolocationGeometry', coordinates: Array<number> } } | null }> | null };

export type GetAllBranchOfficesByJobIdQueryVariables = Exact<{
  profileId?: InputMaybe<Scalars['ID']>;
  jobId: Scalars['ID'];
  search: Scalars['String'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  excludeBranchOfficeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetAllBranchOfficesByJobIdQuery = { __typename?: 'Query', getAllBranchOfficesByJobId: { __typename?: 'BranchOfficePagination', docs: Array<{ __typename?: 'BranchOffice', _id: string, name: string, district?: string | null, province?: string | null, region?: string | null, department?: string | null, distance?: number | null }>, info: { __typename?: 'Pagination', hasNextPage: boolean, page?: number | null, limit: number, nextPage?: number | null, totalDocs: number } } };

export type GetBranchOfficesByJobIdQueryVariables = Exact<{
  profileId?: InputMaybe<Scalars['ID']>;
  jobId: Scalars['ID'];
  search: Scalars['String'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
}>;


export type GetBranchOfficesByJobIdQuery = { __typename?: 'Query', getBranchOfficesByJobId: { __typename?: 'BranchOfficePagination', docs: Array<{ __typename?: 'BranchOffice', _id: string, name: string, district?: string | null, province?: string | null, region?: string | null, department?: string | null, distance?: number | null }>, info: { __typename?: 'Pagination', hasNextPage: boolean, page?: number | null, limit: number, nextPage?: number | null, totalDocs: number } } };

export type GetCareerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCareerQuery = { __typename?: 'Query', getCareer?: { __typename?: 'Career', _id: string, code?: string | null, name?: string | null, cluster?: string | null, iconCluster?: string | null, description?: string | null, search?: string | null, view?: string | null, updatedAt?: any | null } | null };

export type GetCitiesByRegionNameQueryVariables = Exact<{
  regionName: Scalars['String'];
  countryCode: Scalars['String'];
}>;


export type GetCitiesByRegionNameQuery = { __typename?: 'Query', getCitiesByRegionName: Array<string> };

export type GetCountryCode_ProfileQueryVariables = Exact<{
  ip: Scalars['String'];
}>;


export type GetCountryCode_ProfileQuery = { __typename?: 'Query', getCountryCode?: { __typename?: 'KrowdyGeoCountryCode', range: Array<number>, countryCode: string, location?: string | null } | null };

export type GetDistrictsByCityNameQueryVariables = Exact<{
  cityName: Scalars['String'];
  countryCode: Scalars['String'];
}>;


export type GetDistrictsByCityNameQuery = { __typename?: 'Query', getDistrictsByCityName: Array<string> };

export type GetFlowPostulationByProfileIdQueryVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type GetFlowPostulationByProfileIdQuery = { __typename?: 'Query', getFlowPostulationByProfileId: { __typename?: 'FlowPostulationCandidate', type: TypeFlowPostulationCandidate } };

export type GetLocationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationsQuery = { __typename?: 'Query', getLocations: Array<{ __typename?: 'LocationGeolocation', _id: string, countryCode: string }> };

export type GetProfileDateOnetExpiredQueryVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type GetProfileDateOnetExpiredQuery = { __typename?: 'Query', getProfileDateOnetExpired?: { __typename?: 'DateOnetExpired', isFirstJob?: boolean | null, isMaxSixExp?: boolean | null } | null };

export type GetProfileExhaustive_LandQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProfileExhaustive_LandQuery = { __typename?: 'Query', getProfileExhaustive: { __typename?: 'Profile', _id: string, firstName?: string | null, lastName?: string | null, docNumber?: string | null, firstJob?: boolean | null, photo?: string | null, sex?: string | null, civilState?: string | null, birthDate?: any | null, actualPosition?: string | null, aboutMe?: string | null, headline?: string | null, jobPosition?: string | null, competencies?: Array<string> | null, status?: ProfileStatus | null, video?: string | null, createdAt: any, docType: string, dni?: string | null, immigrationCard?: string | null, passport?: string | null, firstProfileSubmissionDate?: any | null, isValidCv?: boolean | null, lastSectionCode?: SectionCode | null, updatedAt: any, nationality?: string | null, flowUpdatedAt?: any | null, flowPostulation?: TypeFlowPostulationCandidate | null, yearsOfExperience?: number | null, isValidatedExperienceFormatDate?: boolean | null, isValidatedEducationFormatDate?: boolean | null, emails: Array<{ __typename?: 'EmailsPhonesResponse', _id: string, type?: string | null, value?: string | null }>, phones: Array<{ __typename?: 'EmailsPhonesResponse', _id: string, type?: string | null, value?: string | null }>, websites: Array<{ __typename?: 'Websites', _id: string, type?: string | null, value?: string | null }>, salaryExpectation?: { __typename?: 'SalaryExpectation', currency?: string | null, amount?: number | null, countryCode?: string | null } | null, especialization: Array<{ __typename?: 'Especialization', _id: string, especializationName?: string | null, especializationtype?: string | null, especializationPlace?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, studyingHere?: boolean | null, condition?: string | null }>, socialNetworks: Array<{ __typename?: 'SocialNetwork', socialNetwork?: string | null, url?: string | null }>, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, filenameOriginal?: string | null, url?: string | null, updatedAt?: string | null } | null, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null, level?: string | null }>, education: Array<{ __typename?: 'Education', _id: string, institutionName?: string | null, degree?: string | null, condition?: string | null, academicArea?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, level?: string | null, description?: string | null, imgUrl?: string | null, career?: string | null, idEducationLaborum?: string | null }>, experience: Array<{ __typename?: 'Experience', _id: string, jobPosition?: string | null, companyName?: string | null, hierarchy?: string | null, location?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, area?: string | null, workHere?: boolean | null, idExperienceLaborum?: string | null }>, referents?: Array<{ __typename?: 'Referents', _id: string, companyName?: string | null, name?: string | null, phoneNumber?: string | null, experienceId?: string | null, position?: string | null }> | null, career?: { __typename?: 'Career', code?: string | null, name?: string | null } | null, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null, zipCode?: string | null, geometry?: { __typename?: 'GeolocationGeometry', type: string, coordinates: Array<number> } | null } | null } };

export type GetRegionsByCountryCodeQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type GetRegionsByCountryCodeQuery = { __typename?: 'Query', getRegionsByCountryCode: Array<string> };

export type ProfileFragmentFragment = { __typename?: 'Profile', _id: string, firstName?: string | null, lastName?: string | null, docNumber?: string | null, firstJob?: boolean | null, photo?: string | null, sex?: string | null, civilState?: string | null, birthDate?: any | null, actualPosition?: string | null, aboutMe?: string | null, headline?: string | null, jobPosition?: string | null, competencies?: Array<string> | null, status?: ProfileStatus | null, video?: string | null, createdAt: any, docType: string, dni?: string | null, immigrationCard?: string | null, passport?: string | null, firstProfileSubmissionDate?: any | null, lastSectionCode?: SectionCode | null, updatedAt: any, nationality?: string | null, flowUpdatedAt?: any | null, flowPostulation?: TypeFlowPostulationCandidate | null, yearsOfExperience?: number | null, emails: Array<{ __typename?: 'EmailsPhonesResponse', _id: string, type?: string | null, value?: string | null }>, phones: Array<{ __typename?: 'EmailsPhonesResponse', _id: string, type?: string | null, value?: string | null }>, websites: Array<{ __typename?: 'Websites', _id: string, type?: string | null, value?: string | null }>, salaryExpectation?: { __typename?: 'SalaryExpectation', currency?: string | null, amount?: number | null, countryCode?: string | null } | null, especialization: Array<{ __typename?: 'Especialization', _id: string, especializationName?: string | null, especializationtype?: string | null, especializationPlace?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, studyingHere?: boolean | null, condition?: string | null }>, socialNetworks: Array<{ __typename?: 'SocialNetwork', socialNetwork?: string | null, url?: string | null }>, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, filenameOriginal?: string | null, url?: string | null, updatedAt?: string | null } | null, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null, level?: string | null }>, education: Array<{ __typename?: 'Education', _id: string, institutionName?: string | null, degree?: string | null, condition?: string | null, academicArea?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, level?: string | null, description?: string | null, imgUrl?: string | null, career?: string | null, idEducationLaborum?: string | null }>, experience: Array<{ __typename?: 'Experience', _id: string, jobPosition?: string | null, companyName?: string | null, hierarchy?: string | null, location?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, area?: string | null, workHere?: boolean | null, idExperienceLaborum?: string | null }>, referents?: Array<{ __typename?: 'Referents', _id: string, companyName?: string | null, name?: string | null, phoneNumber?: string | null, experienceId?: string | null, position?: string | null }> | null, career?: { __typename?: 'Career', code?: string | null, name?: string | null } | null, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null, zipCode?: string | null, geometry?: { __typename?: 'GeolocationGeometry', type: string, coordinates: Array<number> } | null } | null };

export type UploadCvFromEmailMutationVariables = Exact<{
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
  candidateId: Scalars['ID'];
}>;


export type UploadCvFromEmailMutation = { __typename?: 'Mutation', uploadCVFromEmail: { __typename?: 'Candidate', curriculum?: { __typename?: 'Curriculum', url?: string | null } | null } };

export type UpdateAdditionalInformationMutationVariables = Exact<{
  profileId: Scalars['ID'];
  input: AdditionalInformationInput;
}>;


export type UpdateAdditionalInformationMutation = { __typename?: 'Mutation', updateAdditionalInformation?: { __typename?: 'Profile', _id: string, websites: Array<{ __typename?: 'Websites', _id: string, type?: string | null, value?: string | null, title?: string | null }>, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null, level?: string | null }> } | null };

export type UpdateBranchOfficeCandidatesMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  branchOfficeId: Scalars['ID'];
  action: BranchUpdateAction;
  coordinates: Array<Scalars['Float']> | Scalars['Float'];
}>;


export type UpdateBranchOfficeCandidatesMutation = { __typename?: 'Mutation', updateBranchOfficeCandidates: { __typename?: 'Candidate', _id: string, branchOffices?: Array<{ __typename?: 'BranchOfficeCandidate', branchOfficeId: string, available: boolean, distance?: number | null, preview: { __typename?: 'PreviewBranchOfficeCandidate', available: boolean }, branchOffice?: { __typename?: 'BranchOffice', _id: string, name: string, district?: string | null, province?: string | null, region?: string | null, department?: string | null, geometry: { __typename?: 'GeolocationGeometry', coordinates: Array<number> } } | null }> | null } };

export type UpdateCvMutationVariables = Exact<{
  profileId?: InputMaybe<Scalars['ID']>;
  candidateId?: InputMaybe<Scalars['ID']>;
  input: UpdateCvInput;
  fromMail?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCvMutation = { __typename?: 'Mutation', updateCV?: { __typename?: 'Profile', _id: string, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, filenameOriginal?: string | null, url?: string | null, updatedAt?: string | null } | null } | null };

export type UpdateCandidateProfileMutationVariables = Exact<{
  profileId: Scalars['ID'];
}>;


export type UpdateCandidateProfileMutation = { __typename?: 'Mutation', updateCandidateProfile: { __typename?: 'Profile', _id: string } };

export type UpdateEducationMutationVariables = Exact<{
  profileId: Scalars['ID'];
  input?: InputMaybe<EducationAndEspecializationInput>;
  jobId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateEducationMutation = { __typename?: 'Mutation', updateEducation?: { __typename?: 'Profile', _id: string, isValidatedEducationFormatDate?: boolean | null, education: Array<{ __typename?: 'Education', _id: string, institutionName?: string | null, degree?: string | null, condition?: string | null, career?: string | null, academicArea?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, description?: string | null, imgUrl?: string | null, idEducationLaborum?: string | null, level?: string | null }>, especialization: Array<{ __typename?: 'Especialization', especializationName?: string | null, especializationtype?: string | null, especializationPlace?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, description?: string | null, condition?: string | null }> } | null };

export type UpdateExperienceMutationVariables = Exact<{
  profileId: Scalars['ID'];
  input?: InputMaybe<Array<ExperienceInput> | ExperienceInput>;
  jobId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateExperienceMutation = { __typename?: 'Mutation', updateExperience?: { __typename?: 'Profile', _id: string, isValidatedExperienceFormatDate?: boolean | null, experience: Array<{ __typename?: 'Experience', _id: string, jobPosition?: string | null, companyName?: string | null, hierarchy?: string | null, location?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, area?: string | null, workHere?: boolean | null, idExperienceLaborum?: string | null }> } | null };

export type UpdateLastProfileSectionCodeMutationVariables = Exact<{
  profileId: Scalars['ID'];
  sectionCode?: InputMaybe<SectionCode>;
}>;


export type UpdateLastProfileSectionCodeMutation = { __typename?: 'Mutation', updateLastProfileSectionCode: boolean };

export type UpdateProfileBasicInformationMutationVariables = Exact<{
  profileId: Scalars['ID'];
  input: UpdateProfileBasicInformationInput;
}>;


export type UpdateProfileBasicInformationMutation = { __typename?: 'Mutation', updateProfileBasicInformation: { __typename?: 'Profile', _id: string, firstName?: string | null, lastName?: string | null, firstJob?: boolean | null, docNumber?: string | null, photo?: string | null, sex?: string | null, civilState?: string | null, birthDate?: any | null, docType: string, dni?: string | null, immigrationCard?: string | null, passport?: string | null, nationality?: string | null, phones: Array<{ __typename?: 'EmailsPhonesResponse', _id: string, type?: string | null, value?: string | null }>, salaryExpectation?: { __typename?: 'SalaryExpectation', currency?: string | null, amount?: number | null, countryCode?: string | null } | null, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null, zipCode?: string | null, geometry?: { __typename?: 'GeolocationGeometry', type: string, coordinates: Array<number> } | null } | null } };

export type UpdateProfileByGeoLocationMutationVariables = Exact<{
  profileId: Scalars['ID'];
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProfileByGeoLocationMutation = { __typename?: 'Mutation', updateProfileByGeoLocation: { __typename?: 'Profile', _id: string, firstName?: string | null, lastName?: string | null, docNumber?: string | null, firstJob?: boolean | null, photo?: string | null, sex?: string | null, civilState?: string | null, birthDate?: any | null, actualPosition?: string | null, aboutMe?: string | null, headline?: string | null, jobPosition?: string | null, competencies?: Array<string> | null, status?: ProfileStatus | null, video?: string | null, createdAt: any, docType: string, dni?: string | null, immigrationCard?: string | null, passport?: string | null, firstProfileSubmissionDate?: any | null, lastSectionCode?: SectionCode | null, updatedAt: any, nationality?: string | null, flowUpdatedAt?: any | null, flowPostulation?: TypeFlowPostulationCandidate | null, yearsOfExperience?: number | null, emails: Array<{ __typename?: 'EmailsPhonesResponse', _id: string, type?: string | null, value?: string | null }>, phones: Array<{ __typename?: 'EmailsPhonesResponse', _id: string, type?: string | null, value?: string | null }>, websites: Array<{ __typename?: 'Websites', _id: string, type?: string | null, value?: string | null }>, salaryExpectation?: { __typename?: 'SalaryExpectation', currency?: string | null, amount?: number | null, countryCode?: string | null } | null, especialization: Array<{ __typename?: 'Especialization', _id: string, especializationName?: string | null, especializationtype?: string | null, especializationPlace?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, studyingHere?: boolean | null, condition?: string | null }>, socialNetworks: Array<{ __typename?: 'SocialNetwork', socialNetwork?: string | null, url?: string | null }>, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, filenameOriginal?: string | null, url?: string | null, updatedAt?: string | null } | null, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null, level?: string | null }>, education: Array<{ __typename?: 'Education', _id: string, institutionName?: string | null, degree?: string | null, condition?: string | null, academicArea?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, level?: string | null, description?: string | null, imgUrl?: string | null, career?: string | null, idEducationLaborum?: string | null }>, experience: Array<{ __typename?: 'Experience', _id: string, jobPosition?: string | null, companyName?: string | null, hierarchy?: string | null, location?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, area?: string | null, workHere?: boolean | null, idExperienceLaborum?: string | null }>, referents?: Array<{ __typename?: 'Referents', _id: string, companyName?: string | null, name?: string | null, phoneNumber?: string | null, experienceId?: string | null, position?: string | null }> | null, career?: { __typename?: 'Career', code?: string | null, name?: string | null } | null, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null, zipCode?: string | null, geometry?: { __typename?: 'GeolocationGeometry', type: string, coordinates: Array<number> } | null } | null } };

export type UpdateProfileCareerMutationVariables = Exact<{
  profileId: Scalars['ID'];
  input: CareerInput;
}>;


export type UpdateProfileCareerMutation = { __typename?: 'Mutation', updateProfileCareer: { __typename?: 'Profile', _id: string, career?: { __typename?: 'Career', _id: string, code?: string | null, name?: string | null, search?: string | null, view?: string | null, updatedAt?: any | null } | null } };

export type UpdateProfileCoordinatesMutationVariables = Exact<{
  profileId: Scalars['ID'];
  country: Scalars['String'];
  region: Scalars['String'];
  city: Scalars['String'];
  district: Scalars['String'];
  candidateId?: InputMaybe<Scalars['ID']>;
  jobId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateProfileCoordinatesMutation = { __typename?: 'Mutation', updateProfileCoordinates: { __typename?: 'UpdateProfileCoordinatesResponse', candidate?: { __typename?: 'Candidate', _id: string, branchOffices?: Array<{ __typename?: 'BranchOfficeCandidate', branchOfficeId: string, available: boolean, distance?: number | null, preview: { __typename?: 'PreviewBranchOfficeCandidate', available: boolean }, branchOffice?: { __typename?: 'BranchOffice', _id: string, name: string, district?: string | null, province?: string | null, region?: string | null, department?: string | null, geometry: { __typename?: 'GeolocationGeometry', coordinates: Array<number> } } | null }> | null } | null, profile: { __typename?: 'Profile', _id: string, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null, zipCode?: string | null, geometry?: { __typename?: 'GeolocationGeometry', type: string, coordinates: Array<number> } | null } | null } } };

export type UpdateReferentsMutationVariables = Exact<{
  profileId: Scalars['ID'];
  input: Array<LaborReferentInput> | LaborReferentInput;
}>;


export type UpdateReferentsMutation = { __typename?: 'Mutation', updateReferents?: { __typename?: 'Profile', _id: string, referents?: Array<{ __typename?: 'Referents', _id: string, companyName?: string | null, name?: string | null, phoneNumber?: string | null, experienceId?: string | null, position?: string | null }> | null } | null };

export type ApplyEditPostulationMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  sourceApply?: InputMaybe<Scalars['String']>;
}>;


export type ApplyEditPostulationMutation = { __typename?: 'Mutation', applyEditPostulation: { __typename?: 'Candidate', _id: string } };

export type GetAreasQueryVariables = Exact<{
  input?: InputMaybe<PaginationInput>;
}>;


export type GetAreasQuery = { __typename?: 'Query', getAreas: Array<{ __typename?: 'Area', id: string, name: string }> };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', getCountries: Array<{ __typename?: 'Countries', countryCode: string, phoneCode: string, countryNameEsp: string }> };

export type GetCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenciesQuery = { __typename?: 'Query', getCurrencies: Array<{ __typename?: 'Currencies', countryCode: string, currencyCode: string, countryNameEsp: string }> };

export type GetGroupOnetSuggestionsQueryVariables = Exact<{
  textSearch: Scalars['String'];
}>;


export type GetGroupOnetSuggestionsQuery = { __typename?: 'Query', getGroupOnetSuggestions: Array<{ __typename?: 'GroupOnetSuggestion', principalCluster?: string | null, iconCluster?: string | null, iconClusterSVG?: string | null } | null> };

export type GetJobOnetSuggestionsQueryVariables = Exact<{
  textSearch: Scalars['String'];
}>;


export type GetJobOnetSuggestionsQuery = { __typename?: 'Query', getJobOnetSuggestions: Array<{ __typename?: 'FindOnetSuggestion', data?: Array<{ __typename?: 'OnetSuggestion', code?: string | null, codeCluster?: string | null, name?: string | null, cluster?: string | null, description?: string | null } | null> | null, key?: { __typename?: 'GroupOnetSuggestion', iconClusterSVG?: string | null, principalCluster?: string | null } | null } | null> };

export type GetLaborExchangeBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetLaborExchangeBySlugQuery = { __typename?: 'Query', getLaborExchangeBySlug?: { __typename?: 'LaborExchange', _id: string, name: string } | null };

export type GetStorageTokenQueryVariables = Exact<{
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  assetType: AssetType;
  routeId: Scalars['String'];
  subFlow?: InputMaybe<Scalars['String']>;
  generalFlow?: InputMaybe<GeneralFlow>;
}>;


export type GetStorageTokenQuery = { __typename?: 'Query', getStorageToken: { __typename?: 'TokenObject', token: string, originalFileName: string, fileName: string, key: string, contentType: string, acl: string, url: string } };

export type GetTaskByIdQueryVariables = Exact<{
  taskId?: InputMaybe<Scalars['ID']>;
}>;


export type GetTaskByIdQuery = { __typename?: 'Query', getTaskById: { __typename?: 'Task', _id: string, isActive?: boolean | null, alias?: string | null, categoryTask: { __typename?: 'CategoryTask', _id: string, isSchedulable?: boolean | null, urlExec?: string | null, pathContentForm: string, title?: string | null }, taskConfig?: { __typename?: 'TaskConfig', krowderGroups: Array<{ __typename?: 'KrowderGroup', krowderGroupId?: string | null, count: number }> } | null } };

export type ResetTaskMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
}>;


export type ResetTaskMutation = { __typename?: 'Mutation', resetTask: { __typename?: 'SuccessResponse', success?: boolean | null } };

export type UpdateFirstTimeInMutationVariables = Exact<{
  input: UpdateFirstTimeInInput;
}>;


export type UpdateFirstTimeInMutation = { __typename?: 'Mutation', updateFirstTimeIn: { __typename?: 'SuccessResponse', success?: boolean | null } };

export type UpdateTaskDateMutationVariables = Exact<{
  input: UpdateTaskDateInput;
}>;


export type UpdateTaskDateMutation = { __typename?: 'Mutation', updateTaskDate: { __typename?: 'SuccessResponse', success?: boolean | null } };

export type VerifyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifyUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', _id: string, email: string, firstName?: string | null, lastName?: string | null, photo?: string | null } | null };

export type CandidateFragmentFragment = { __typename?: 'Candidate', _id: string, firstName?: string | null, lastName?: string | null, stageId?: string | null, profileSubmissionDate?: any | null, oauthSocialToken?: string | null, email?: string | null, userId?: string | null, phone?: string | null, jobId: string, status: CandidateStatus, fullName?: string | null, photo?: string | null, sendPostulationReminderMail?: any | null, applyDate?: any | null, isProfileUpdateValidated?: boolean | null, lastManualStageId?: string | null, applyInstanceStatus: CandidateStatus, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, url?: string | null } | null, candidateTasks: Array<{ __typename?: 'CandidateTask', _id: string, candidateId: string, taskId: string, resultTaskId?: string | null, taskDate?: any | null, firstTimeIn?: string | null, wasNotified?: boolean | null, stageId: string, applyInstanceStatus: CandidateTaskStatus, lastActionRequests?: Array<{ __typename?: 'ActionRequest', code: ActionRequestCode, status: ActionRequestStatus }> | null }>, lastActionRequests?: Array<{ __typename?: 'ActionRequest', code: ActionRequestCode, status: ActionRequestStatus }> | null, branchOffices?: Array<{ __typename?: 'BranchOfficeCandidate', branchOfficeId: string, available: boolean, distance?: number | null, preview: { __typename?: 'PreviewBranchOfficeCandidate', available: boolean }, branchOffice?: { __typename?: 'BranchOffice', _id: string, name: string, district?: string | null, province?: string | null, region?: string | null, department?: string | null, geometry: { __typename?: 'GeolocationGeometry', coordinates: Array<number> } } | null }> | null, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null, zipCode?: string | null, geometry?: { __typename?: 'GeolocationGeometry', type: string, coordinates: Array<number> } | null } | null };

export type GetCandidate_Main_LayoutQueryVariables = Exact<{
  jobId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  trackingCandidateId?: InputMaybe<Scalars['ID']>;
  sourceApply?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidate_Main_LayoutQuery = { __typename?: 'Query', getCandidate: { __typename?: 'Candidate', _id: string, firstName?: string | null, lastName?: string | null, stageId?: string | null, profileSubmissionDate?: any | null, oauthSocialToken?: string | null, email?: string | null, userId?: string | null, phone?: string | null, jobId: string, status: CandidateStatus, fullName?: string | null, photo?: string | null, sendPostulationReminderMail?: any | null, applyDate?: any | null, isProfileUpdateValidated?: boolean | null, lastManualStageId?: string | null, applyInstanceStatus: CandidateStatus, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, url?: string | null } | null, candidateTasks: Array<{ __typename?: 'CandidateTask', _id: string, candidateId: string, taskId: string, resultTaskId?: string | null, taskDate?: any | null, firstTimeIn?: string | null, wasNotified?: boolean | null, stageId: string, applyInstanceStatus: CandidateTaskStatus, lastActionRequests?: Array<{ __typename?: 'ActionRequest', code: ActionRequestCode, status: ActionRequestStatus }> | null }>, lastActionRequests?: Array<{ __typename?: 'ActionRequest', code: ActionRequestCode, status: ActionRequestStatus }> | null, branchOffices?: Array<{ __typename?: 'BranchOfficeCandidate', branchOfficeId: string, available: boolean, distance?: number | null, preview: { __typename?: 'PreviewBranchOfficeCandidate', available: boolean }, branchOffice?: { __typename?: 'BranchOffice', _id: string, name: string, district?: string | null, province?: string | null, region?: string | null, department?: string | null, geometry: { __typename?: 'GeolocationGeometry', coordinates: Array<number> } } | null }> | null, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null, zipCode?: string | null, geometry?: { __typename?: 'GeolocationGeometry', type: string, coordinates: Array<number> } | null } | null } };

export type GetApplyJob_Main_LayoutQueryVariables = Exact<{
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
}>;


export type GetApplyJob_Main_LayoutQuery = { __typename?: 'Query', job: { __typename?: 'Job', _id: string, title: string, hasBranchOfficeJobs?: boolean | null, regions: Array<string>, mergeJobId?: string | null, companyPublished?: { __typename?: 'Company', _id?: string | null, name?: string | null, photo?: string | null, premium?: boolean | null, profile?: { __typename?: 'CompanyProfile', _id?: string | null, logo?: string | null } | null } | null, companyConfig?: { __typename?: 'CompanyConfig', applyConfig?: { __typename?: 'ApplyConfig', experienceRangeFormatDate?: string | null, educationRangeFormatDate?: string | null, applyButtonText?: string | null, hiddenDrawer?: boolean | null, sendApplicationButtonText?: string | null, congratulationsDescription?: string | null, hiddenRecommendedJobs?: boolean | null, hiddenKrowdyInfo?: boolean | null, headerSupportDisabled?: boolean | null, headerTutorialDisabled?: boolean | null, isNotConsideringCv?: boolean | null, codeTasksWithSubmitButtonAlwaysVisible?: Array<string> | null, leavePostulationButtonText?: string | null, leavePostulationDialogTitle?: string | null, externalHire?: { __typename?: 'ExternalHire', externalUrl?: string | null, isEnabled?: boolean | null } | null } | null, notificationsConfig?: { __typename?: 'NotificationsConfig', isEnabledCandidateCompletedRegister?: boolean | null } | null } | null, publications: Array<{ __typename?: 'Publication', _id: string, location?: string | null, title?: string | null, area?: string | null, hierarchy?: string | null, journeyType?: string | null, firstPublicationDate?: any | null, expirationDate?: any | null, status?: PublicationStatus | null, publishday?: any | null, experience?: number | null, careers?: Array<string | null> | null, availabilityToTravel?: boolean | null, confidentialCompany?: boolean | null, contractType?: string | null, salary?: { __typename?: 'Salary', from?: number | null, to?: number | null, typeOfMoney?: string | null, visible?: boolean | null } | null, profile?: { __typename?: 'ProfileJob', basicEdition?: Array<{ __typename?: 'BasicEdition', _id?: string | null, visible?: boolean | null, title?: string | null, description?: string | null } | null> | null, competencies?: Array<{ __typename?: 'Competence', _id?: string | null, description?: string | null, title?: string | null } | null> | null, languages?: Array<{ __typename?: 'Language', language?: string | null, level?: string | null } | null> | null } | null, benefitsOfWork?: Array<{ __typename?: 'Benefit', description?: string | null, title?: string | null } | null> | null, disability?: { __typename?: 'Disability', accepted?: boolean | null, visible?: boolean | null } | null, educationLevel?: { __typename?: 'Education', condition?: string | null, level?: string | null } | null }>, similarOnets?: Array<{ __typename?: 'SimilarOnets', onetCode?: string | null, jobPosition?: string | null } | null> | null, massApplication?: { __typename?: 'MassApplication', allBranchOffices?: boolean | null, multiSelect?: boolean | null, enabled?: boolean | null, cv?: boolean | null, profile?: boolean | null, salaryExpectationDisabled?: boolean | null } | null, templates?: Array<{ __typename?: 'JobTemplate', templateId: string, templateName?: string | null }> | null, stages: Array<{ __typename?: 'Stage', _id: string, name: string, tasks: Array<{ __typename?: 'Task', _id: string, alias?: string | null, stageId?: string | null, taskConfig?: { __typename?: 'TaskConfig', krowderGroups: Array<{ __typename?: 'KrowderGroup', krowderGroupId?: string | null, count: number }> } | null, categoryTask: { __typename?: 'CategoryTask', _id: string, pathContentForm: string, title?: string | null, urlExec?: string | null, urlApi?: string | null, urlIcon?: string | null, urlImage?: string | null, useMediaRecorder?: boolean | null, isSchedulable?: boolean | null, byKrowdy?: boolean | null, isLinkExternal?: boolean | null, canBeEditPostulation?: boolean | null, isExecutableByCall?: boolean | null } }> }> } };

export type GetTheme_Main_LayoutQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
}>;


export type GetTheme_Main_LayoutQuery = { __typename?: 'Query', getTheme?: { __typename?: 'Theme', cssTextFamily?: string | null, palette: { __typename?: 'ThemePalette', background?: { __typename?: 'ThemePaletteConfig', default?: string | null } | null, primary: { __typename?: 'ThemePaletteConfig', main?: string | null, medium?: string | null }, secondary: { __typename?: 'ThemePaletteConfig', main?: string | null }, text?: { __typename?: 'ThemePaletteConfig', primary?: string | null, secondary?: string | null, tertiary?: string | null } | null, custom?: { __typename?: 'ThemePaletteConfig', main?: string | null } | null }, typography?: { __typename?: 'ThemeTypography', fontFamily: string } | null, overrides?: { __typename?: 'Overrides', MuiCardContent?: any | null, MuiDivider?: any | null, MuiOutlinedInput?: any | null } | null } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', _id: string, email: string, firstName?: string | null, lastName?: string | null, photo?: string | null } | null };

export type JobStagesFragmentFragment = { __typename?: 'Job', _id: string, stages: Array<{ __typename?: 'Stage', _id: string, name: string, tasks: Array<{ __typename?: 'Task', _id: string, alias?: string | null, stageId?: string | null, taskConfig?: { __typename?: 'TaskConfig', krowderGroups: Array<{ __typename?: 'KrowderGroup', krowderGroupId?: string | null, count: number }> } | null, categoryTask: { __typename?: 'CategoryTask', _id: string, pathContentForm: string, title?: string | null, urlExec?: string | null, urlApi?: string | null, urlIcon?: string | null, urlImage?: string | null, useMediaRecorder?: boolean | null, isSchedulable?: boolean | null, byKrowdy?: boolean | null, isLinkExternal?: boolean | null, canBeEditPostulation?: boolean | null, isExecutableByCall?: boolean | null } }> }> };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'Response', success: boolean, data?: any | null } | null };

export type SendPostulationReminderMailMutationVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type SendPostulationReminderMailMutation = { __typename?: 'Mutation', sendPostulationReminderMail?: { __typename?: 'Candidate', _id: string } | null };

export type UpdateProfileValidationMutationVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type UpdateProfileValidationMutation = { __typename?: 'Mutation', updateProfileValidation?: { __typename?: 'Candidate', _id: string, isProfileUpdateValidated?: boolean | null } | null };

export type ValidInvitationCodeByUserTypeMutationVariables = Exact<{
  invitationCode: Scalars['String'];
  scope: Scalars['String'];
  userType: Scalars['String'];
}>;


export type ValidInvitationCodeByUserTypeMutation = { __typename?: 'Mutation', validInvitationCodeByUserType: string };

export type CreateResultTask_InternalappsMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
  taskId: Scalars['ID'];
  jobId: Scalars['ID'];
}>;


export type CreateResultTask_InternalappsMutation = { __typename?: 'Mutation', createResultTask: { __typename?: 'CandidateTask', _id: string, candidateId: string, taskId: string, resultTaskId?: string | null, status: CandidateTaskStatus } };

export type Executed_InternalappsMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
}>;


export type Executed_InternalappsMutation = { __typename?: 'Mutation', executed: { __typename?: 'CandidateTask', _id: string, candidateId: string, taskId: string, resultTaskId?: string | null, status: CandidateTaskStatus, isIntroductionViewed?: boolean | null } };

export type FinishMultitest_InternalappsMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
  resultTaskId: Scalars['String'];
}>;


export type FinishMultitest_InternalappsMutation = { __typename?: 'Mutation', finishMultitest: { __typename?: 'CandidateTask', _id: string, candidateId: string, taskId: string, resultTaskId?: string | null, status: CandidateTaskStatus } };

export type GetCandidateTask_InternalappsQueryVariables = Exact<{
  candidateTaskId: Scalars['ID'];
}>;


export type GetCandidateTask_InternalappsQuery = { __typename?: 'Query', getCandidateTask: { __typename?: 'CandidateTask', _id: string, candidateId: string, taskId: string, resultTaskId?: string | null, status: CandidateTaskStatus, isIntroductionViewed?: boolean | null, resultTasks?: Array<any> | null, candidateInfo?: { __typename?: 'CandidateInfoCreateTaskResult', email?: string | null, phone?: string | null, firstName?: string | null, lastName?: string | null, docNumber?: string | null, age?: string | null, gender?: string | null } | null, task: { __typename?: 'Task', _id: string, contentTask?: { __typename?: 'ContentTask', content?: any | null } | null, categoryTask: { __typename?: 'CategoryTask', _id: string, urlExec?: string | null, title?: string | null, pathContentForm: string } } } };

export type UpdateBasicCandidateTask_InternalappsMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
  input: UpdateBasicCandidateTaskInput;
}>;


export type UpdateBasicCandidateTask_InternalappsMutation = { __typename?: 'Mutation', updateBasicCandidateTask: { __typename?: 'CandidateTask', _id: string, isIntroductionViewed?: boolean | null } };

export type UpdateCandidateInfo_InternalappsMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
  input: UpdateCandidateInfoInput;
}>;


export type UpdateCandidateInfo_InternalappsMutation = { __typename?: 'Mutation', updateCandidateInfo: { __typename?: 'CandidateTask', _id: string, candidateInfo?: { __typename?: 'CandidateInfoCreateTaskResult', email?: string | null, phone?: string | null, firstName?: string | null, lastName?: string | null, docNumber?: string | null, age?: string | null, gender?: string | null } | null } };

export type ValidAndCreateNewResultTaskMutationVariables = Exact<{
  codeTask: Scalars['String'];
  resultTaskId: Scalars['String'];
  candidateTaskId: Scalars['ID'];
  actionRequestCode: Scalars['String'];
}>;


export type ValidAndCreateNewResultTaskMutation = { __typename?: 'Mutation', validAndCreateNewResultTask: string };

export type CandidateInfoFragmentFragment = { __typename?: 'Candidate', _id: string, jobId: string, stageId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, fullName?: string | null, location?: string | null, applyInstanceStatus: CandidateStatus, gender?: string | null, docNumber?: string | null, docType?: string | null, nationality?: string | null, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, url?: string | null } | null, especialization: Array<{ __typename?: 'Especialization', _id: string, especializationName?: string | null, especializationtype?: string | null, especializationPlace?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, studyingHere?: boolean | null, condition?: string | null }>, education: Array<{ __typename?: 'Education', _id: string, institutionName?: string | null, degree?: string | null, condition?: string | null, academicArea?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, level?: string | null, description?: string | null, imgUrl?: string | null, career?: string | null }>, experience: Array<{ __typename?: 'Experience', _id: string, jobPosition?: string | null, companyName?: string | null, hierarchy?: string | null, location?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, area?: string | null, workHere?: boolean | null }>, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null } | null, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null, level?: string | null }>, websites: Array<{ __typename?: 'Websites', _id: string, type?: string | null, value?: string | null }>, salaryExpectation?: { __typename?: 'SalaryExpectation', _id?: string | null, currency?: string | null, amount?: number | null, countryCode?: string | null } | null };

export type CreateResultTask_LandMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
  taskId: Scalars['ID'];
  jobId: Scalars['ID'];
}>;


export type CreateResultTask_LandMutation = { __typename?: 'Mutation', createResultTask: { __typename?: 'CandidateTask', _id: string, candidateId: string, taskId: string, resultTaskId?: string | null, status: CandidateTaskStatus } };

export type GetAppSections_LandQueryVariables = Exact<{
  candidateTaskId: Scalars['ID'];
  taskId: Scalars['ID'];
}>;


export type GetAppSections_LandQuery = { __typename?: 'Query', getAppSections: Array<{ __typename?: 'Section', isWildCard?: boolean | null, needValidBeforeToRender?: boolean | null, sectionCode?: SectionCode | null, hiddenWhileCurrentSectionIsIncomplete?: boolean | null, completed?: boolean | null, valid?: boolean | null }> };

export type GetCandidateByEmailExactQueryVariables = Exact<{
  email: Scalars['String'];
  jobId: Scalars['ID'];
}>;


export type GetCandidateByEmailExactQuery = { __typename?: 'Query', getCandidateByEmailExact?: { __typename?: 'Candidate', _id: string, email?: string | null } | null };

export type GetCandidate_InfoQueryVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type GetCandidate_InfoQuery = { __typename?: 'Query', candidate: { __typename?: 'Candidate', _id: string, jobId: string, stageId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, fullName?: string | null, location?: string | null, applyInstanceStatus: CandidateStatus, gender?: string | null, docNumber?: string | null, docType?: string | null, nationality?: string | null, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, url?: string | null } | null, especialization: Array<{ __typename?: 'Especialization', _id: string, especializationName?: string | null, especializationtype?: string | null, especializationPlace?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, studyingHere?: boolean | null, condition?: string | null }>, education: Array<{ __typename?: 'Education', _id: string, institutionName?: string | null, degree?: string | null, condition?: string | null, academicArea?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, level?: string | null, description?: string | null, imgUrl?: string | null, career?: string | null }>, experience: Array<{ __typename?: 'Experience', _id: string, jobPosition?: string | null, companyName?: string | null, hierarchy?: string | null, location?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, area?: string | null, workHere?: boolean | null }>, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null } | null, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null, level?: string | null }>, websites: Array<{ __typename?: 'Websites', _id: string, type?: string | null, value?: string | null }>, salaryExpectation?: { __typename?: 'SalaryExpectation', _id?: string | null, currency?: string | null, amount?: number | null, countryCode?: string | null } | null } };

export type GetCandidateTask_LandQueryVariables = Exact<{
  candidateTaskId: Scalars['ID'];
}>;


export type GetCandidateTask_LandQuery = { __typename?: 'Query', getCandidateTask: { __typename?: 'CandidateTask', _id: string, candidateId: string, taskId: string, resultTaskId?: string | null, applyInstanceStatus: CandidateTaskStatus, firstTimeIn?: string | null, isIntroductionViewed?: boolean | null } };

export type GetApplyJob_LandQueryVariables = Exact<{
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
}>;


export type GetApplyJob_LandQuery = { __typename?: 'Query', job: { __typename?: 'Job', _id: string, title: string, hasBranchOfficeJobs?: boolean | null, companyPublished?: { __typename?: 'Company', _id?: string | null, name?: string | null, photo?: string | null, premium?: boolean | null, profile?: { __typename?: 'CompanyProfile', _id?: string | null, logo?: string | null } | null } | null, companyConfig?: { __typename?: 'CompanyConfig', applyConfig?: { __typename?: 'ApplyConfig', experienceRangeFormatDate?: string | null, educationRangeFormatDate?: string | null, applyButtonText?: string | null, hiddenDrawer?: boolean | null, sendApplicationButtonText?: string | null, congratulationsDescription?: string | null, hiddenRecommendedJobs?: boolean | null, hiddenKrowdyInfo?: boolean | null, headerSupportDisabled?: boolean | null, headerTutorialDisabled?: boolean | null, isNotConsideringCv?: boolean | null, codeTasksWithSubmitButtonAlwaysVisible?: Array<string> | null, leavePostulationButtonText?: string | null, leavePostulationDialogTitle?: string | null, externalHire?: { __typename?: 'ExternalHire', externalUrl?: string | null, isEnabled?: boolean | null } | null } | null, notificationsConfig?: { __typename?: 'NotificationsConfig', isEnabledCandidateCompletedRegister?: boolean | null } | null } | null, stages: Array<{ __typename?: 'Stage', _id: string, name: string, tasks: Array<{ __typename?: 'Task', _id: string, alias?: string | null, stageId?: string | null, categoryTask: { __typename?: 'CategoryTask', _id: string, pathContentForm: string, title?: string | null, urlExec?: string | null, urlApi?: string | null, urlIcon?: string | null, urlImage?: string | null, useMediaRecorder?: boolean | null, isSchedulable?: boolean | null, byKrowdy?: boolean | null, isLinkExternal?: boolean | null, canBeEditPostulation?: boolean | null, isExecutableByCall?: boolean | null }, taskConfig?: { __typename?: 'TaskConfig', krowderGroups: Array<{ __typename?: 'KrowderGroup', krowderGroupId?: string | null, count: number }> } | null }> }>, massApplication?: { __typename?: 'MassApplication', allBranchOffices?: boolean | null, multiSelect?: boolean | null, enabled?: boolean | null, cv?: boolean | null, profile?: boolean | null, salaryExpectationDisabled?: boolean | null } | null } };

export type GetSimilarJobs_CongratulationsQueryVariables = Exact<{
  jobId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetSimilarJobs_CongratulationsQuery = { __typename?: 'Query', getSimilarJobs: Array<{ __typename?: 'JobSimilar', _id: string, title: string, jobDetail?: { __typename?: 'JobDetail', _id?: string | null, title?: string | null, expirationDate?: any | null, basicEdition?: Array<{ __typename?: 'BasicEdition', _id?: string | null, visible?: boolean | null, title?: string | null, description?: string | null } | null> | null, benefitsOfWork?: Array<{ __typename?: 'Benefit', description?: string | null, title?: string | null } | null> | null, disability?: { __typename?: 'Disability', accepted?: boolean | null, visible?: boolean | null } | null, detailJob?: Array<{ __typename?: 'Detail', title?: string | null, value?: any | null } | null> | null } | null, companyPublished?: { __typename?: 'Company', _id?: string | null, name?: string | null, photo?: string | null, profile?: { __typename?: 'CompanyProfile', _id?: string | null, logo?: string | null } | null } | null }> };

export type GetTheme_LandQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
}>;


export type GetTheme_LandQuery = { __typename?: 'Query', getTheme?: { __typename?: 'Theme', cssTextFamily?: string | null, palette: { __typename?: 'ThemePalette', background?: { __typename?: 'ThemePaletteConfig', default?: string | null } | null, primary: { __typename?: 'ThemePaletteConfig', main?: string | null, medium?: string | null }, secondary: { __typename?: 'ThemePaletteConfig', main?: string | null }, text?: { __typename?: 'ThemePaletteConfig', primary?: string | null, secondary?: string | null, tertiary?: string | null } | null, custom?: { __typename?: 'ThemePaletteConfig', main?: string | null } | null }, typography?: { __typename?: 'ThemeTypography', fontFamily: string } | null, overrides?: { __typename?: 'Overrides', MuiCardContent?: any | null, MuiDivider?: any | null, MuiOutlinedInput?: any | null } | null } | null };

export type MoveLastManualStageId_LandMutationVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type MoveLastManualStageId_LandMutation = { __typename?: 'Mutation', moveLastManualStageId?: { __typename?: 'Candidate', _id: string } | null };

export type NotifyAdminsCandidateCompletedFirstStageMutationVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type NotifyAdminsCandidateCompletedFirstStageMutation = { __typename?: 'Mutation', notifyAdminsCandidateCompletedFirstStage: { __typename?: 'SuccessType', success?: boolean | null, message?: string | null } };

export type NotifyMultipleFlowInterviewMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
  jobId: Scalars['ID'];
  typeMessage: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
  executeDate?: InputMaybe<Scalars['String']>;
  executeHour?: InputMaybe<Scalars['String']>;
  executeMinutes?: InputMaybe<Scalars['String']>;
}>;


export type NotifyMultipleFlowInterviewMutation = { __typename?: 'Mutation', notifyMultipleFlowInterview: { __typename?: 'SuccessResponse', success?: boolean | null } };

export type NotifyOpenTaskInDesktop_LandMutationVariables = Exact<{
  taskId: Scalars['ID'];
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
  slug?: InputMaybe<Scalars['String']>;
}>;


export type NotifyOpenTaskInDesktop_LandMutation = { __typename?: 'Mutation', notifyOpenTaskInDesktop: { __typename?: 'Candidate', _id: string } };

export type SendEditPostulationMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  sourcePostulant?: InputMaybe<Scalars['String']>;
}>;


export type SendEditPostulationMutation = { __typename?: 'Mutation', sendEditPostulation: { __typename?: 'Candidate', _id: string, status: CandidateStatus } };

export type SendProfile_LandMutationVariables = Exact<{
  profileId: Scalars['ID'];
  jobId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  candidateId: Scalars['ID'];
  sourcePostulant?: InputMaybe<Scalars['String']>;
}>;


export type SendProfile_LandMutation = { __typename?: 'Mutation', sendProfile: { __typename?: 'Profile', _id: string } };

export type UpdateCandidateMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  input: CandidateInput;
}>;


export type UpdateCandidateMutation = { __typename?: 'Mutation', updateCandidate: { __typename?: 'Candidate', _id: string, jobId: string, stageId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, fullName?: string | null, location?: string | null, applyInstanceStatus: CandidateStatus, gender?: string | null, docNumber?: string | null, docType?: string | null, nationality?: string | null, curriculum?: { __typename?: 'Curriculum', fileName?: string | null, url?: string | null } | null, especialization: Array<{ __typename?: 'Especialization', _id: string, especializationName?: string | null, especializationtype?: string | null, especializationPlace?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, studyingHere?: boolean | null, condition?: string | null }>, education: Array<{ __typename?: 'Education', _id: string, institutionName?: string | null, degree?: string | null, condition?: string | null, academicArea?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, level?: string | null, description?: string | null, imgUrl?: string | null, career?: string | null }>, experience: Array<{ __typename?: 'Experience', _id: string, jobPosition?: string | null, companyName?: string | null, hierarchy?: string | null, location?: string | null, startDate?: any | null, endDate?: any | null, description?: string | null, imgUrl?: string | null, area?: string | null, workHere?: boolean | null }>, geolocation?: { __typename?: 'CandidateGeolocation', country?: string | null, region?: string | null, city?: string | null, location?: string | null, district?: string | null } | null, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null, level?: string | null }>, websites: Array<{ __typename?: 'Websites', _id: string, type?: string | null, value?: string | null }>, salaryExpectation?: { __typename?: 'SalaryExpectation', _id?: string | null, currency?: string | null, amount?: number | null, countryCode?: string | null } | null } };

export type UpdateCandidatePhonesMutationVariables = Exact<{
  candidateId: Scalars['ID'];
  phones?: InputMaybe<Array<EmailsPhonesResponseInput> | EmailsPhonesResponseInput>;
}>;


export type UpdateCandidatePhonesMutation = { __typename?: 'Mutation', updateCandidatePhones?: { __typename?: 'SuccessType', message?: string | null, success?: boolean | null } | null };

export type ValidateCvMutationVariables = Exact<{
  profileId: Scalars['ID'];
  jobId: Scalars['ID'];
}>;


export type ValidateCvMutation = { __typename?: 'Mutation', validateCv: boolean };

export type AssignTask_LobbyMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
}>;


export type AssignTask_LobbyMutation = { __typename?: 'Mutation', assignTask?: string | null };

export type GetCandidateTaskByTaskAndUser_LobbyQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type GetCandidateTaskByTaskAndUser_LobbyQuery = { __typename?: 'Query', getCandidateTaskByTaskAndUser?: { __typename?: 'CandidateTask', _id: string, resultTaskId?: string | null, status: CandidateTaskStatus, categoryTask?: { __typename?: 'CategoryTask', _id: string, urlExec?: string | null } | null } | null };

export type GetCandidateTasksByTask_LobbyQueryVariables = Exact<{
  taskId: Scalars['ID'];
}>;


export type GetCandidateTasksByTask_LobbyQuery = { __typename?: 'Query', getCandidateTasksByTask: Array<{ __typename?: 'CandidateTask', _id: string, status: CandidateTaskStatus, candidateId: string, taskDate?: any | null, resultTaskId?: string | null, categoryTask?: { __typename?: 'CategoryTask', _id: string, urlExec?: string | null } | null, candidate?: { __typename?: 'Candidate', _id: string, email?: string | null, firstName?: string | null, lastName?: string | null, userId?: string | null, photo?: string | null } | null }> };

export type VerifyKey_LobbyQueryVariables = Exact<{
  taskId: Scalars['ID'];
  responsableKey: Scalars['String'];
}>;


export type VerifyKey_LobbyQuery = { __typename?: 'Query', verifyKey: { __typename?: 'SuccessResponse', success?: boolean | null } };

export type CreateBasicCandidateFromFormMutationVariables = Exact<{
  docNumber: Scalars['String'];
  docType: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  jobId: Scalars['String'];
  utm?: InputMaybe<UtmInput>;
}>;


export type CreateBasicCandidateFromFormMutation = { __typename?: 'Mutation', createBasicCandidateFromForm: { __typename?: 'SuccessType', success?: boolean | null, message?: string | null } };

export type AddMergeTokenToCandidateMutationVariables = Exact<{
  jobId: Scalars['ID'];
  trackId: Scalars['ID'];
  email: Scalars['String'];
}>;


export type AddMergeTokenToCandidateMutation = { __typename?: 'Mutation', addMergeTokenToCandidate?: { __typename?: 'CandidateInfo', candidateId: string, status: string } | null };

export type AddUserOnMergeCandidateMutationVariables = Exact<{
  jobId: Scalars['ID'];
  trackId: Scalars['ID'];
  token: Scalars['String'];
}>;


export type AddUserOnMergeCandidateMutation = { __typename?: 'Mutation', addUserOnMergeCandidate?: { __typename?: 'CandidateInfo', candidateId: string, status: string } | null };

export type GetCandidateByIdQueryVariables = Exact<{
  candidateId: Scalars['ID'];
}>;


export type GetCandidateByIdQuery = { __typename?: 'Query', getCandidateById: { __typename?: 'Candidate', _id: string, email?: string | null } };

export type GetCandidate_PublicationQueryVariables = Exact<{
  jobId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  trackingCandidateId?: InputMaybe<Scalars['ID']>;
  sourceApply?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidate_PublicationQuery = { __typename?: 'Query', getCandidate: { __typename?: 'Candidate', _id: string, firstName?: string | null, lastName?: string | null, yearsOfExperience?: number | null, experience: Array<{ __typename?: 'Experience', _id: string, startDate?: any | null, endDate?: any | null, workHere?: boolean | null, jobPosition?: string | null, companyName?: string | null }>, education: Array<{ __typename?: 'Education', _id: string, career?: string | null, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null }>, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null }> } };

export type GetApplyJob_PublicationQueryVariables = Exact<{
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
}>;


export type GetApplyJob_PublicationQuery = { __typename?: 'Query', job: { __typename?: 'Job', _id: string, title: string, regions: Array<string>, publications: Array<{ __typename?: 'Publication', _id: string, status?: PublicationStatus | null, location?: string | null, title?: string | null, area?: string | null, hierarchy?: string | null, journeyType?: string | null, experience?: number | null, careers?: Array<string | null> | null, availabilityToTravel?: boolean | null, confidentialCompany?: boolean | null, contractType?: string | null, expirationDate?: any | null, salary?: { __typename?: 'Salary', from?: number | null, to?: number | null, typeOfMoney?: string | null, visible?: boolean | null } | null, profile?: { __typename?: 'ProfileJob', basicEdition?: Array<{ __typename?: 'BasicEdition', _id?: string | null, visible?: boolean | null, title?: string | null, description?: string | null } | null> | null, competencies?: Array<{ __typename?: 'Competence', _id?: string | null, description?: string | null, title?: string | null } | null> | null, languages?: Array<{ __typename?: 'Language', language?: string | null, level?: string | null } | null> | null } | null, benefitsOfWork?: Array<{ __typename?: 'Benefit', description?: string | null, title?: string | null } | null> | null, disability?: { __typename?: 'Disability', accepted?: boolean | null, visible?: boolean | null } | null, educationLevel?: { __typename?: 'Education', condition?: string | null, level?: string | null } | null }>, companyPublished?: { __typename?: 'Company', _id?: string | null, name?: string | null, photo?: string | null, premium?: boolean | null, profile?: { __typename?: 'CompanyProfile', _id?: string | null, logo?: string | null } | null, branding?: { __typename?: 'BrandingCompany', referents?: boolean | null } | null } | null, companyConfig?: { __typename?: 'CompanyConfig', profile?: { __typename?: 'CompanyConfigProfile', _id?: string | null, colorBanner?: string | null } | null, applyConfig?: { __typename?: 'ApplyConfig', applyButtonText?: string | null, hiddenDrawer?: boolean | null, sendApplicationButtonText?: string | null, congratulationsDescription?: string | null, hiddenRecommendedJobs?: boolean | null, hiddenKrowdyInfo?: boolean | null, headerSupportDisabled?: boolean | null, headerTutorialDisabled?: boolean | null, isNotConsideringCv?: boolean | null, codeTasksWithSubmitButtonAlwaysVisible?: Array<string> | null, leavePostulationButtonText?: string | null, leavePostulationDialogTitle?: string | null, externalHire?: { __typename?: 'ExternalHire', externalUrl?: string | null, isEnabled?: boolean | null } | null } | null, notificationsConfig?: { __typename?: 'NotificationsConfig', isEnabledCandidateCompletedRegister?: boolean | null } | null } | null, massApplication?: { __typename?: 'MassApplication', allBranchOffices?: boolean | null, multiSelect?: boolean | null, enabled?: boolean | null, cv?: boolean | null, profile?: boolean | null, salaryExpectationDisabled?: boolean | null } | null } };

export type GetLocationJobByCoordinatesQueryVariables = Exact<{
  jobId: Scalars['ID'];
  lat: Scalars['String'];
  lng: Scalars['String'];
}>;


export type GetLocationJobByCoordinatesQuery = { __typename?: 'Query', getLocationJobByCoordinates: { __typename?: 'JobLocation', location?: string | null, regions: Array<string> } };

export type GetProfileExhaustive_PublicationQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProfileExhaustive_PublicationQuery = { __typename?: 'Query', getProfileExhaustive: { __typename?: 'Profile', _id: string, firstName?: string | null, lastName?: string | null, knowledge: Array<{ __typename?: 'Knowledge', _id: string, knowledgeName?: string | null }>, education: Array<{ __typename?: 'Education', _id: string, startDate?: any | null, endDate?: any | null, studyingHere?: boolean | null, career?: string | null }>, experience: Array<{ __typename?: 'Experience', _id: string, jobPosition?: string | null, companyName?: string | null, startDate?: any | null, endDate?: any | null, imgUrl?: string | null, workHere?: boolean | null }> } };

export type AddReferralsMutationVariables = Exact<{
  jobId: Scalars['ID'];
  referentId: Scalars['ID'];
  columns?: InputMaybe<Scalars['JSON']>;
  referrals: Array<ReferredInput> | ReferredInput;
  urlCsv?: InputMaybe<Scalars['String']>;
}>;


export type AddReferralsMutation = { __typename?: 'Mutation', addReferrals: { __typename?: 'AddReferralsResponse', totalInsertedDocs: number, totalNoInsertedDocs: number } };

export type CreateReferentMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CreateReferentMutation = { __typename?: 'Mutation', createReferent: { __typename?: 'Referent', _id: string, brandingCompany?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } };

export type MassiveColumnMatchedQueryVariables = Exact<{
  urlFile: Scalars['String'];
}>;


export type MassiveColumnMatchedQuery = { __typename?: 'Query', massiveColumnMatched: Array<string> };

export type MassiveFindDuplicatedCandidatesQueryVariables = Exact<{
  jobId: Scalars['ID'];
  url: Scalars['String'];
  columns: Scalars['JSON'];
}>;


export type MassiveFindDuplicatedCandidatesQuery = { __typename?: 'Query', massiveFindDuplicatedCandidates: { __typename?: 'MassiveFindDuplicatedCandidatesResponse', totalCandidatesToFilter: number } };

export type UpdateReferentMutationVariables = Exact<{
  jobId: Scalars['ID'];
  referentId: Scalars['ID'];
  input: ReferentInput;
}>;


export type UpdateReferentMutation = { __typename?: 'Mutation', updateReferent: { __typename?: 'Referent', _id: string, brandingCompany?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } };

export type ValidAndFinishResultTaskMutationVariables = Exact<{
  candidateTaskId: Scalars['ID'];
}>;


export type ValidAndFinishResultTaskMutation = { __typename?: 'Mutation', validAndFinishResultTask: { __typename?: 'SuccessTypeResult', success?: boolean | null, finished?: boolean | null } };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
};

export type ActionRequest = {
  __typename?: 'ActionRequest';
  _id: Scalars['ID'];
  code: ActionRequestCode;
  createdAt: Scalars['Date'];
  createdById: Scalars['ID'];
  finishedAt?: Maybe<Scalars['Date']>;
  finishedByUserId?: Maybe<Scalars['ID']>;
  finishedByUserType?: Maybe<UserType>;
  refId: Scalars['ID'];
  refType: ActionRequestRefType;
  status: ActionRequestStatus;
  updatedAt: Scalars['Date'];
};

export enum ActionRequestCode {
  Reset = 'RESET',
  Update = 'UPDATE'
}

export enum ActionRequestRefType {
  Candidate = 'CANDIDATE',
  CandidateTask = 'CANDIDATE_TASK'
}

export enum ActionRequestStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type AddReferralsResponse = {
  __typename?: 'AddReferralsResponse';
  totalInsertedDocs: Scalars['Int'];
  totalNoInsertedDocs: Scalars['Int'];
};

export type AddReferralsResponseReferent = {
  __typename?: 'AddReferralsResponseReferent';
  email?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<EmailsPhonesResponse>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<EmailsPhonesResponse>>;
  socialNetworks?: Maybe<Array<SocialNetwork>>;
};

export type AdditionalEntityFields = {
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type AdditionalInformationInput = {
  knowledge?: InputMaybe<Array<KnowledgeInput>>;
  websites?: InputMaybe<Array<WebsitesInput>>;
};

export type ApplyConfig = {
  __typename?: 'ApplyConfig';
  applyButtonText?: Maybe<Scalars['String']>;
  codeTasksWithSubmitButtonAlwaysVisible?: Maybe<Array<Scalars['String']>>;
  congratulationsDescription?: Maybe<Scalars['String']>;
  congratulationsTitle?: Maybe<Scalars['String']>;
  educationRangeFormatDate?: Maybe<Scalars['String']>;
  experienceRangeFormatDate?: Maybe<Scalars['String']>;
  externalHire?: Maybe<ExternalHire>;
  headerSupportDisabled?: Maybe<Scalars['Boolean']>;
  headerTutorialDisabled?: Maybe<Scalars['Boolean']>;
  hiddenDrawer?: Maybe<Scalars['Boolean']>;
  hiddenKrowdyInfo?: Maybe<Scalars['Boolean']>;
  hiddenRecommendedJobs?: Maybe<Scalars['Boolean']>;
  isNotConsideringCv?: Maybe<Scalars['Boolean']>;
  leavePostulationButtonText?: Maybe<Scalars['String']>;
  leavePostulationDialogTitle?: Maybe<Scalars['String']>;
  sendApplicationButtonText?: Maybe<Scalars['String']>;
};

export type Area = {
  __typename?: 'Area';
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum AssetType {
  Avatar = 'AVATAR',
  Cv = 'CV',
  CvCandidate = 'CV_CANDIDATE',
  Docs = 'DOCS',
  ReferentCsv = 'REFERENT_CSV'
}

export type BasicEdition = {
  __typename?: 'BasicEdition';
  _id?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type Benefit = {
  __typename?: 'Benefit';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BranchOffice = {
  __typename?: 'BranchOffice';
  _id: Scalars['ID'];
  address?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  district?: Maybe<Scalars['String']>;
  geometry: GeolocationGeometry;
  isDeleted: Scalars['Boolean'];
  jobId: Scalars['ID'];
  name: Scalars['String'];
  province?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  territory?: Maybe<Scalars['String']>;
};

export type BranchOfficeCandidate = {
  __typename?: 'BranchOfficeCandidate';
  assigned: Scalars['Boolean'];
  assignedAt?: Maybe<Scalars['Date']>;
  assignedById?: Maybe<Scalars['ID']>;
  authCreatedById: Scalars['ID'];
  available: Scalars['Boolean'];
  branchOffice?: Maybe<BranchOffice>;
  branchOfficeId: Scalars['ID'];
  createdAt: Scalars['Date'];
  distance?: Maybe<Scalars['Float']>;
  near: Scalars['Boolean'];
  preview: PreviewBranchOfficeCandidate;
  statusScore: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BranchOfficePagination = {
  __typename?: 'BranchOfficePagination';
  docs: Array<BranchOffice>;
  info: Pagination;
};

export enum BranchUpdateAction {
  Pull = 'PULL',
  Push = 'PUSH'
}

export type BrandingCompany = {
  __typename?: 'BrandingCompany';
  referents?: Maybe<Scalars['Boolean']>;
};

export type Candidate = {
  __typename?: 'Candidate';
  _id: Scalars['ID'];
  applyDate?: Maybe<Scalars['Date']>;
  applyInstanceStatus: CandidateStatus;
  birthDate?: Maybe<Scalars['String']>;
  branchOffices?: Maybe<Array<BranchOfficeCandidate>>;
  candidateTasks: Array<CandidateTask>;
  career?: Maybe<Career>;
  civilState?: Maybe<Scalars['String']>;
  curriculum?: Maybe<Curriculum>;
  docNumber?: Maybe<Scalars['String']>;
  docType?: Maybe<Scalars['String']>;
  education: Array<Education>;
  email?: Maybe<Scalars['String']>;
  especialization: Array<Especialization>;
  experience: Array<Experience>;
  firstJob?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  geolocation?: Maybe<CandidateGeolocation>;
  isProfileUpdateValidated?: Maybe<Scalars['Boolean']>;
  jobId: Scalars['ID'];
  knowledge: Array<Knowledge>;
  lastActionRequests?: Maybe<Array<ActionRequest>>;
  lastManualStageId?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  oauthSocialToken?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  profileSubmissionDate?: Maybe<Scalars['Date']>;
  salaryExpectation?: Maybe<SalaryExpectation>;
  sendPostulationReminderMail?: Maybe<Scalars['Date']>;
  socialNetworks?: Maybe<Array<SocialNetwork>>;
  stageId?: Maybe<Scalars['ID']>;
  status: CandidateStatus;
  userId?: Maybe<Scalars['ID']>;
  websites: Array<Websites>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
};

export type CandidateGeolocation = {
  __typename?: 'CandidateGeolocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  geometry?: Maybe<GeolocationGeometry>;
  location?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CandidateInfo = {
  __typename?: 'CandidateInfo';
  candidateId: Scalars['String'];
  status: Scalars['String'];
};

export type CandidateInfoCreateTaskResult = {
  __typename?: 'CandidateInfoCreateTaskResult';
  age?: Maybe<Scalars['String']>;
  candidateState?: Maybe<CandidateStatus>;
  docNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CandidateInfoToken = {
  __typename?: 'CandidateInfoToken';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CandidateInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  actualPosition?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['String']>;
  civilState?: InputMaybe<Scalars['String']>;
  curriculum?: InputMaybe<CurriculumInput>;
  deparment?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  docNumber?: InputMaybe<Scalars['String']>;
  docType?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Array<EducationInput>>;
  email?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<EmailsPhonesResponseInput>>;
  especialization?: InputMaybe<Array<EspecializationInput>>;
  experience?: InputMaybe<Array<ExperienceInput>>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  geolocation?: InputMaybe<GeolocationInput>;
  jobId: Scalars['ID'];
  jobPosition?: InputMaybe<Scalars['String']>;
  knowledge?: InputMaybe<Array<KnowledgeInput>>;
  lastName?: InputMaybe<Scalars['String']>;
  latlon?: InputMaybe<LatLonInput>;
  linkedin?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<EmailsPhonesResponseInput>>;
  photo?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  salaryExpectation?: InputMaybe<SalaryExpectationInput>;
  socialNetworks?: InputMaybe<Array<SocialNetworkInput>>;
  stageId: Scalars['ID'];
  userId?: InputMaybe<Scalars['String']>;
  websites?: InputMaybe<Array<WebsitesInput>>;
  yearsOfExperience?: InputMaybe<Scalars['Float']>;
};

export enum CandidateStatus {
  Acknowledged = 'acknowledged',
  Apply = 'apply',
  Backup = 'backup',
  Deleted = 'deleted',
  Invited = 'invited',
  Leave = 'leave',
  Linkedin = 'linkedin',
  New = 'new',
  PositionFilledEmail = 'position_filled_email',
  Postulant = 'postulant',
  Rejected = 'rejected',
  Winner = 'winner'
}

export type CandidateTask = {
  __typename?: 'CandidateTask';
  _id: Scalars['ID'];
  applyInstanceStatus: CandidateTaskStatus;
  candidate?: Maybe<Candidate>;
  candidateId: Scalars['ID'];
  candidateInfo?: Maybe<CandidateInfoCreateTaskResult>;
  categoryTask?: Maybe<CategoryTask>;
  executedAt?: Maybe<Scalars['Date']>;
  firstTimeIn?: Maybe<Scalars['String']>;
  hasBotHelper?: Maybe<Scalars['Boolean']>;
  hasIntroduction?: Maybe<Scalars['Boolean']>;
  isIntroductionViewed?: Maybe<Scalars['Boolean']>;
  jobId: Scalars['ID'];
  lastActionRequests?: Maybe<Array<ActionRequest>>;
  resultTaskId?: Maybe<Scalars['String']>;
  resultTasks?: Maybe<Array<Scalars['JSON']>>;
  stageId: Scalars['ID'];
  status: CandidateTaskStatus;
  task: Task;
  taskDate?: Maybe<Scalars['Date']>;
  taskId: Scalars['ID'];
  timezone?: Maybe<TimezoneType>;
  updateContentTask?: Maybe<Scalars['Boolean']>;
  wasNotified?: Maybe<Scalars['Boolean']>;
};

export enum CandidateTaskStatus {
  Doing = 'doing',
  Executed = 'executed',
  Pending = 'pending',
  Reviewed = 'reviewed'
}

export type Career = {
  __typename?: 'Career';
  _id: Scalars['ID'];
  cluster?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iconCluster?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  view?: Maybe<Scalars['String']>;
};

export type CareerInput = {
  cluster?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  iconCluster?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  view?: InputMaybe<Scalars['String']>;
};

export type CategoryTask = {
  __typename?: 'CategoryTask';
  _id: Scalars['ID'];
  byKrowdy?: Maybe<Scalars['Boolean']>;
  canBeEditPostulation?: Maybe<Scalars['Boolean']>;
  isExecutableByCall?: Maybe<Scalars['Boolean']>;
  isLinkExternal?: Maybe<Scalars['Boolean']>;
  isSchedulable?: Maybe<Scalars['Boolean']>;
  pathContentForm: Scalars['String'];
  templateEmails?: Maybe<CustomTemplatesEmails>;
  title?: Maybe<Scalars['String']>;
  urlApi?: Maybe<Scalars['String']>;
  urlAssign?: Maybe<Scalars['String']>;
  urlExec?: Maybe<Scalars['String']>;
  urlIcon?: Maybe<Scalars['String']>;
  urlImage?: Maybe<Scalars['String']>;
  useMediaRecorder?: Maybe<Scalars['Boolean']>;
};

export type Company = {
  __typename?: 'Company';
  _id?: Maybe<Scalars['ID']>;
  branding?: Maybe<BrandingCompany>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  premium?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<CompanyProfile>;
  slug?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['JSON']>;
};

export type CompanyConfig = {
  __typename?: 'CompanyConfig';
  applyConfig?: Maybe<ApplyConfig>;
  notificationsConfig?: Maybe<NotificationsConfig>;
  profile?: Maybe<CompanyConfigProfile>;
};

export type CompanyConfigProfile = {
  __typename?: 'CompanyConfigProfile';
  _id?: Maybe<Scalars['ID']>;
  colorBanner?: Maybe<Scalars['String']>;
};

export type CompanyProfile = {
  __typename?: 'CompanyProfile';
  _id?: Maybe<Scalars['ID']>;
  colorBanner?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
};

export type Competence = {
  __typename?: 'Competence';
  _id?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ContentTask = {
  __typename?: 'ContentTask';
  content?: Maybe<Scalars['JSON']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type Countries = {
  __typename?: 'Countries';
  countryCode: Scalars['String'];
  countryNameEsp: Scalars['String'];
  phoneCode: Scalars['String'];
};

export type Currencies = {
  __typename?: 'Currencies';
  countryCode: Scalars['String'];
  countryNameEsp: Scalars['String'];
  currencyCode: Scalars['String'];
};

export type Curriculum = {
  __typename?: 'Curriculum';
  fileName?: Maybe<Scalars['String']>;
  filenameOriginal?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CurriculumInput = {
  fileName?: InputMaybe<Scalars['String']>;
  filenameOriginal?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CustomTemplatesEmails = {
  __typename?: 'CustomTemplatesEmails';
  Canceled?: Maybe<TemplateEmailsParams>;
  Confirm?: Maybe<TemplateEmailsParams>;
  ReSchedule?: Maybe<TemplateEmailsParams>;
  ToJoin?: Maybe<TemplateEmailsParams>;
  ToStart?: Maybe<TemplateEmailsParams>;
  schedule?: Maybe<TemplateEmailsParams>;
};

export type DateOnetExpired = {
  __typename?: 'DateOnetExpired';
  isFirstJob?: Maybe<Scalars['Boolean']>;
  isMaxSixExp?: Maybe<Scalars['Boolean']>;
};

export type Detail = {
  __typename?: 'Detail';
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type Disability = {
  __typename?: 'Disability';
  accepted?: Maybe<Scalars['Boolean']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export enum DocumentType {
  Curp = 'CURP',
  Rfc = 'RFC',
  Dni = 'dni',
  ImmigrationCard = 'immigrationCard',
  Passport = 'passport'
}

export type DuplicatedCandidate = {
  __typename?: 'DuplicatedCandidate';
  _id: Scalars['ID'];
  docNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status: CandidateStatus;
};

export type Education = {
  __typename?: 'Education';
  _id: Scalars['ID'];
  academicArea?: Maybe<Scalars['String']>;
  career?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  idEducationLaborum?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  institutionName?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  studyingHere?: Maybe<Scalars['Boolean']>;
};

export type EducationAndEspecializationInput = {
  education?: InputMaybe<Array<InputMaybe<EducationInput>>>;
  especialization?: InputMaybe<Array<InputMaybe<EspecializationInput>>>;
};

export type EducationInput = {
  _id: Scalars['ID'];
  academicArea?: InputMaybe<Scalars['String']>;
  career?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<Scalars['String']>;
  degree?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  idEducationLaborum?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  institutionName: Scalars['String'];
  level?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  studyingHere?: InputMaybe<Scalars['Boolean']>;
};

export type EmailsPhonesResponse = {
  __typename?: 'EmailsPhonesResponse';
  _id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EmailsPhonesResponseInput = {
  _id: Scalars['ID'];
  socialNetwork?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Especialization = {
  __typename?: 'Especialization';
  _id: Scalars['ID'];
  condition?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  especializationName?: Maybe<Scalars['String']>;
  especializationPlace?: Maybe<Scalars['String']>;
  especializationtype?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  studyingHere?: Maybe<Scalars['Boolean']>;
};

export type EspecializationInput = {
  _id: Scalars['ID'];
  condition?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  especializationName?: InputMaybe<Scalars['String']>;
  especializationPlace?: InputMaybe<Scalars['String']>;
  especializationtype?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  studyingHere?: InputMaybe<Scalars['Boolean']>;
};

export type Experience = {
  __typename?: 'Experience';
  _id: Scalars['ID'];
  area?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  hierarchy?: Maybe<Scalars['String']>;
  idExperienceLaborum?: Maybe<Scalars['String']>;
  imgUrl?: Maybe<Scalars['String']>;
  jobPosition?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  workHere?: Maybe<Scalars['Boolean']>;
};

export type ExperienceInput = {
  _id: Scalars['ID'];
  area?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  hierarchy?: InputMaybe<Scalars['String']>;
  idExperienceLaborum?: InputMaybe<Scalars['String']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  jobPosition?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  workHere?: InputMaybe<Scalars['Boolean']>;
};

export type ExternalHire = {
  __typename?: 'ExternalHire';
  externalUrl?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
};

export type FindOnetSuggestion = {
  __typename?: 'FindOnetSuggestion';
  data?: Maybe<Array<Maybe<OnetSuggestion>>>;
  key?: Maybe<GroupOnetSuggestion>;
};

export type FlowPostulationCandidate = {
  __typename?: 'FlowPostulationCandidate';
  type: TypeFlowPostulationCandidate;
};

export enum GeneralFlow {
  Applying = 'applying',
  Ats = 'ats'
}

export type Geolocation = {
  __typename?: 'Geolocation';
  _id: Scalars['ID'];
  cityName: Scalars['String'];
  cityNameEs?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  countryNameEs?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  districtNameEs?: Maybe<Scalars['String']>;
  geometry?: Maybe<GeolocationGeometry>;
  search?: Maybe<Scalars['String']>;
  searchEs?: Maybe<Scalars['String']>;
  stateName: Scalars['String'];
  stateNameEs?: Maybe<Scalars['String']>;
};

export type GeolocationGeometry = {
  __typename?: 'GeolocationGeometry';
  coordinates: Array<Scalars['Float']>;
  type: Scalars['String'];
};

export type GeolocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

export type GeolocationSuggestion = {
  __typename?: 'GeolocationSuggestion';
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Coordinates>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type GroupOnetSuggestion = {
  __typename?: 'GroupOnetSuggestion';
  iconCluster?: Maybe<Scalars['String']>;
  iconClusterSVG?: Maybe<Scalars['String']>;
  principalCluster?: Maybe<Scalars['String']>;
  suggestedPositions?: Maybe<Array<Maybe<OnetSuggestion>>>;
};

export type Hierarchy = {
  __typename?: 'Hierarchy';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type IpLocation = {
  __typename?: 'IpLocation';
  _id?: Maybe<Scalars['String']>;
  capital?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  continent?: Maybe<Scalars['String']>;
  continentCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  ipType?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  phoneCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type Job = {
  __typename?: 'Job';
  _id: Scalars['ID'];
  companyConfig?: Maybe<CompanyConfig>;
  companyPublished?: Maybe<Company>;
  hasBranchOfficeJobs?: Maybe<Scalars['Boolean']>;
  massApplication?: Maybe<MassApplication>;
  mergeJobId?: Maybe<Scalars['ID']>;
  publications: Array<Publication>;
  regions: Array<Scalars['String']>;
  similarOnets?: Maybe<Array<Maybe<SimilarOnets>>>;
  stages: Array<Stage>;
  templates?: Maybe<Array<JobTemplate>>;
  title: Scalars['String'];
  userPublishJob?: Maybe<User>;
};

export type JobDetail = {
  __typename?: 'JobDetail';
  _id?: Maybe<Scalars['ID']>;
  basicEdition?: Maybe<Array<Maybe<BasicEdition>>>;
  benefitsOfWork?: Maybe<Array<Maybe<Benefit>>>;
  description?: Maybe<Scalars['String']>;
  detailJob?: Maybe<Array<Maybe<Detail>>>;
  disability?: Maybe<Disability>;
  expirationDate?: Maybe<Scalars['Date']>;
  firstPublicationDate?: Maybe<Scalars['Date']>;
  publishday?: Maybe<Scalars['Date']>;
  requirements?: Maybe<Array<Maybe<Detail>>>;
  title?: Maybe<Scalars['String']>;
  visibleInformation?: Maybe<Scalars['Boolean']>;
};

export type JobLocation = {
  __typename?: 'JobLocation';
  location?: Maybe<Scalars['String']>;
  regions: Array<Scalars['String']>;
};

export type JobSimilar = {
  __typename?: 'JobSimilar';
  _id: Scalars['ID'];
  companyPublished?: Maybe<Company>;
  jobDetail?: Maybe<JobDetail>;
  title: Scalars['String'];
};

export type JobTemplate = {
  __typename?: 'JobTemplate';
  applied?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  pinned?: Maybe<Scalars['Boolean']>;
  tagIds?: Maybe<Array<Scalars['ID']>>;
  templateId: Scalars['ID'];
  templateName?: Maybe<Scalars['String']>;
};

export type Knowledge = {
  __typename?: 'Knowledge';
  _id: Scalars['ID'];
  knowledgeName?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
};

export type KnowledgeInput = {
  _id: Scalars['ID'];
  knowledgeName?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['String']>;
};

export type KrowderGroup = {
  __typename?: 'KrowderGroup';
  count: Scalars['Int'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  krowderGroupId?: Maybe<Scalars['ID']>;
};

export type KrowdyGeoCountryCode = {
  __typename?: 'KrowdyGeoCountryCode';
  countryCode: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  range: Array<Scalars['Float']>;
};

export type LaborExchange = {
  __typename?: 'LaborExchange';
  _id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  theme?: Maybe<LaborExchangeTheme>;
};

export type LaborExchangeTemplate = {
  __typename?: 'LaborExchangeTemplate';
  header: LaborExchangeTemplateHeader;
};

export type LaborExchangeTemplateHeader = {
  __typename?: 'LaborExchangeTemplateHeader';
  background?: Maybe<Scalars['String']>;
  logo?: Maybe<LaborExchangeTemplateHeaderLogo>;
};

export type LaborExchangeTemplateHeaderLogo = {
  __typename?: 'LaborExchangeTemplateHeaderLogo';
  source?: Maybe<Scalars['String']>;
  sourceHeader?: Maybe<Scalars['String']>;
};

export type LaborExchangeTheme = {
  __typename?: 'LaborExchangeTheme';
  template: LaborExchangeTemplate;
};

export type LaborReferentInput = {
  _id: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  experienceId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
};

export type Language = {
  __typename?: 'Language';
  language?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
};

export type LatLonInput = {
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  address: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  geometry?: Maybe<Scalars['JSON']>;
};

export type LocationGeolocation = {
  __typename?: 'LocationGeolocation';
  _id: Scalars['ID'];
  cityName?: Maybe<Scalars['String']>;
  cityNameEs?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  countryName?: Maybe<Scalars['String']>;
  countryNameEs?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  districtNameEs?: Maybe<Scalars['String']>;
  geometry?: Maybe<LocationGeometry>;
  search?: Maybe<Scalars['String']>;
  searchEs?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
  stateNameEs?: Maybe<Scalars['String']>;
};

export type LocationGeometry = {
  __typename?: 'LocationGeometry';
  coordinates: Array<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type MassApplication = {
  __typename?: 'MassApplication';
  allBranchOffices?: Maybe<Scalars['Boolean']>;
  cv?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  multiSelect?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<Scalars['Boolean']>;
  salaryExpectationDisabled?: Maybe<Scalars['Boolean']>;
};

export type MassiveFindDuplicatedCandidatesResponse = {
  __typename?: 'MassiveFindDuplicatedCandidatesResponse';
  candidates: Array<DuplicatedCandidate>;
  candidatesErrorEmail?: Maybe<Array<Scalars['JSON']>>;
  totalCandidatesToFilter: Scalars['Int'];
  totalNewRecords: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addMergeTokenToCandidate?: Maybe<CandidateInfo>;
  addReferrals: AddReferralsResponse;
  addUserOnMergeCandidate?: Maybe<CandidateInfo>;
  applyEditPostulation: Candidate;
  assignTask?: Maybe<Scalars['String']>;
  createBasicCandidateFromForm: SuccessType;
  createReferent: Referent;
  createResultTask: CandidateTask;
  executed: CandidateTask;
  finishMultitest: CandidateTask;
  leavePostulation: SuccessResponse;
  logout?: Maybe<Response>;
  moveLastManualStageId?: Maybe<Candidate>;
  notifyAdminsCandidateCompletedFirstStage: SuccessType;
  notifyMultipleFlowInterview: SuccessResponse;
  notifyOpenTaskInDesktop: Candidate;
  resetTask: SuccessResponse;
  sendEditPostulation: Candidate;
  sendMagnetoResponseByJobIdAndMagnetoMatchId: SuccessType;
  sendPostulationReminderMail?: Maybe<Candidate>;
  sendProfile: Profile;
  updateAdditionalInformation?: Maybe<Profile>;
  updateBasicCandidateTask: CandidateTask;
  updateBranchOfficeCandidates: Candidate;
  updateCV?: Maybe<Profile>;
  updateCandidate: Candidate;
  updateCandidateInfo: CandidateTask;
  updateCandidatePhones?: Maybe<SuccessType>;
  updateCandidateProfile: Profile;
  updateEducation?: Maybe<Profile>;
  updateExperience?: Maybe<Profile>;
  updateFirstTimeIn: SuccessResponse;
  updateLastProfileSectionCode: Scalars['Boolean'];
  updateProfileBasicInformation: Profile;
  updateProfileByGeoLocation: Profile;
  updateProfileCareer: Profile;
  updateProfileCoordinates: UpdateProfileCoordinatesResponse;
  updateProfileValidation?: Maybe<Candidate>;
  updateReferent: Referent;
  updateReferents?: Maybe<Profile>;
  updateTaskDate: SuccessResponse;
  uploadCVFromEmail: Candidate;
  validAndCreateNewResultTask: Scalars['String'];
  validAndFinishResultTask: SuccessTypeResult;
  validInvitationCodeByUserType: Scalars['String'];
  validateCv: Scalars['Boolean'];
};


export type MutationAddMergeTokenToCandidateArgs = {
  email: Scalars['String'];
  jobId: Scalars['ID'];
  trackId: Scalars['ID'];
};


export type MutationAddReferralsArgs = {
  columns?: InputMaybe<Scalars['JSON']>;
  jobId: Scalars['ID'];
  referentId: Scalars['ID'];
  referrals: Array<ReferredInput>;
  urlCsv?: InputMaybe<Scalars['String']>;
};


export type MutationAddUserOnMergeCandidateArgs = {
  jobId: Scalars['ID'];
  token: Scalars['String'];
  trackId: Scalars['ID'];
};


export type MutationApplyEditPostulationArgs = {
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  sourceApply?: InputMaybe<Scalars['String']>;
};


export type MutationAssignTaskArgs = {
  candidateTaskId: Scalars['ID'];
};


export type MutationCreateBasicCandidateFromFormArgs = {
  docNumber: Scalars['String'];
  docType: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  jobId: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  utm?: InputMaybe<UtmInput>;
};


export type MutationCreateReferentArgs = {
  jobId: Scalars['ID'];
};


export type MutationCreateResultTaskArgs = {
  candidateTaskId: Scalars['ID'];
  jobId: Scalars['ID'];
  taskId: Scalars['ID'];
};


export type MutationExecutedArgs = {
  candidateTaskId: Scalars['ID'];
};


export type MutationFinishMultitestArgs = {
  candidateTaskId: Scalars['ID'];
  resultTaskId: Scalars['String'];
};


export type MutationLeavePostulationArgs = {
  candidateId: Scalars['String'];
};


export type MutationMoveLastManualStageIdArgs = {
  candidateId: Scalars['ID'];
};


export type MutationNotifyAdminsCandidateCompletedFirstStageArgs = {
  candidateId: Scalars['ID'];
};


export type MutationNotifyMultipleFlowInterviewArgs = {
  candidateTaskId: Scalars['ID'];
  executeDate?: InputMaybe<Scalars['String']>;
  executeHour?: InputMaybe<Scalars['String']>;
  executeMinutes?: InputMaybe<Scalars['String']>;
  executeUrl?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  typeMessage: Scalars['String'];
};


export type MutationNotifyOpenTaskInDesktopArgs = {
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
  slug?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
};


export type MutationResetTaskArgs = {
  candidateTaskId: Scalars['ID'];
};


export type MutationSendEditPostulationArgs = {
  candidateId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  sourcePostulant?: InputMaybe<Scalars['String']>;
};


export type MutationSendMagnetoResponseByJobIdAndMagnetoMatchIdArgs = {
  jobId: Scalars['ID'];
  magnetoMatchId: Scalars['ID'];
};


export type MutationSendPostulationReminderMailArgs = {
  candidateId: Scalars['ID'];
};


export type MutationSendProfileArgs = {
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
  profileId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  sourcePostulant?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAdditionalInformationArgs = {
  input: AdditionalInformationInput;
  profileId: Scalars['ID'];
};


export type MutationUpdateBasicCandidateTaskArgs = {
  candidateTaskId: Scalars['ID'];
  input: UpdateBasicCandidateTaskInput;
};


export type MutationUpdateBranchOfficeCandidatesArgs = {
  action: BranchUpdateAction;
  branchOfficeId: Scalars['ID'];
  candidateId: Scalars['ID'];
  coordinates: Array<Scalars['Float']>;
};


export type MutationUpdateCvArgs = {
  candidateId?: InputMaybe<Scalars['ID']>;
  fromMail?: InputMaybe<Scalars['Boolean']>;
  input: UpdateCvInput;
  profileId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateCandidateArgs = {
  candidateId: Scalars['ID'];
  input: CandidateInput;
};


export type MutationUpdateCandidateInfoArgs = {
  candidateTaskId: Scalars['ID'];
  input: UpdateCandidateInfoInput;
};


export type MutationUpdateCandidatePhonesArgs = {
  candidateId: Scalars['ID'];
  phones?: InputMaybe<Array<EmailsPhonesResponseInput>>;
};


export type MutationUpdateCandidateProfileArgs = {
  profileId: Scalars['ID'];
};


export type MutationUpdateEducationArgs = {
  input?: InputMaybe<EducationAndEspecializationInput>;
  jobId?: InputMaybe<Scalars['ID']>;
  profileId: Scalars['ID'];
};


export type MutationUpdateExperienceArgs = {
  input?: InputMaybe<Array<ExperienceInput>>;
  jobId?: InputMaybe<Scalars['ID']>;
  profileId: Scalars['ID'];
};


export type MutationUpdateFirstTimeInArgs = {
  input: UpdateFirstTimeInInput;
};


export type MutationUpdateLastProfileSectionCodeArgs = {
  profileId: Scalars['ID'];
  sectionCode?: InputMaybe<SectionCode>;
};


export type MutationUpdateProfileBasicInformationArgs = {
  input: UpdateProfileBasicInformationInput;
  profileId: Scalars['ID'];
};


export type MutationUpdateProfileByGeoLocationArgs = {
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  profileId: Scalars['ID'];
};


export type MutationUpdateProfileCareerArgs = {
  input: CareerInput;
  profileId: Scalars['ID'];
};


export type MutationUpdateProfileCoordinatesArgs = {
  candidateId?: InputMaybe<Scalars['ID']>;
  city: Scalars['String'];
  country: Scalars['String'];
  district: Scalars['String'];
  jobId?: InputMaybe<Scalars['ID']>;
  profileId: Scalars['ID'];
  region: Scalars['String'];
};


export type MutationUpdateProfileValidationArgs = {
  candidateId: Scalars['ID'];
};


export type MutationUpdateReferentArgs = {
  input: ReferentInput;
  jobId: Scalars['ID'];
  referentId: Scalars['ID'];
};


export type MutationUpdateReferentsArgs = {
  input?: InputMaybe<Array<LaborReferentInput>>;
  profileId: Scalars['ID'];
};


export type MutationUpdateTaskDateArgs = {
  input: UpdateTaskDateInput;
};


export type MutationUploadCvFromEmailArgs = {
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
  slug?: InputMaybe<Scalars['String']>;
};


export type MutationValidAndCreateNewResultTaskArgs = {
  actionRequestCode: Scalars['String'];
  candidateTaskId: Scalars['ID'];
  codeTask: Scalars['String'];
  resultTaskId: Scalars['String'];
};


export type MutationValidAndFinishResultTaskArgs = {
  candidateTaskId: Scalars['ID'];
};


export type MutationValidInvitationCodeByUserTypeArgs = {
  invitationCode: Scalars['String'];
  scope: Scalars['String'];
  userType: Scalars['String'];
};


export type MutationValidateCvArgs = {
  jobId?: InputMaybe<Scalars['ID']>;
  profileId: Scalars['ID'];
};

export type NotificationsConfig = {
  __typename?: 'NotificationsConfig';
  isDisabledCampaignNewApplyCandidates?: Maybe<Scalars['Boolean']>;
  isDisabledMakeWinnerCandidate?: Maybe<Scalars['Boolean']>;
  isDisabledMoveStage?: Maybe<Scalars['Boolean']>;
  isDisabledRejectCandidate?: Maybe<Scalars['Boolean']>;
  isEnabledCandidateCompletedRegister?: Maybe<Scalars['Boolean']>;
};

export type OnetSuggestion = {
  __typename?: 'OnetSuggestion';
  cluster?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeCluster?: Maybe<Scalars['String']>;
  codePathway?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iconCluster?: Maybe<Scalars['String']>;
  iconClusterSVG?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pathWay?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  synonyms?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
};

export type Overrides = {
  __typename?: 'Overrides';
  MuiCardContent?: Maybe<Scalars['JSON']>;
  MuiDivider?: Maybe<Scalars['JSON']>;
  MuiOutlinedInput?: Maybe<Scalars['JSON']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  meta?: Maybe<Scalars['JSON']>;
  nextPage?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter: Scalars['Int'];
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PaginationInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

export type PreviewBranchOfficeCandidate = {
  __typename?: 'PreviewBranchOfficeCandidate';
  available: Scalars['Boolean'];
};

export type Profile = {
  __typename?: 'Profile';
  _id: Scalars['ID'];
  aboutMe?: Maybe<Scalars['String']>;
  actualPosition?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  candidateId?: Maybe<Scalars['ID']>;
  career?: Maybe<Career>;
  civilState?: Maybe<Scalars['String']>;
  competencies?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Date'];
  curriculum?: Maybe<Curriculum>;
  deleted: Scalars['Boolean'];
  dni?: Maybe<Scalars['String']>;
  docNumber?: Maybe<Scalars['String']>;
  docType: Scalars['String'];
  education: Array<Education>;
  emails: Array<EmailsPhonesResponse>;
  especialization: Array<Especialization>;
  executedById?: Maybe<Scalars['ID']>;
  executerUserType?: Maybe<UserType>;
  experience: Array<Experience>;
  firstJob?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  firstProfileSubmissionDate?: Maybe<Scalars['Date']>;
  flowPostulation?: Maybe<TypeFlowPostulationCandidate>;
  flowUpdatedAt?: Maybe<Scalars['Date']>;
  geolocation?: Maybe<CandidateGeolocation>;
  headline?: Maybe<Scalars['String']>;
  idUser?: Maybe<Scalars['String']>;
  immigrationCard?: Maybe<Scalars['String']>;
  isValidCv?: Maybe<Scalars['Boolean']>;
  isValidatedEducationFormatDate?: Maybe<Scalars['Boolean']>;
  isValidatedExperienceFormatDate?: Maybe<Scalars['Boolean']>;
  jobPosition?: Maybe<Scalars['String']>;
  knowledge: Array<Knowledge>;
  lastFlowPostulation?: Maybe<Scalars['String']>;
  lastJobId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastSectionCode?: Maybe<SectionCode>;
  location?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  passport?: Maybe<Scalars['String']>;
  phones: Array<EmailsPhonesResponse>;
  photo?: Maybe<Scalars['String']>;
  referents?: Maybe<Array<Referents>>;
  salaryExpectation?: Maybe<SalaryExpectation>;
  sex?: Maybe<Scalars['String']>;
  socialNetworks: Array<SocialNetwork>;
  status?: Maybe<ProfileStatus>;
  updatedAt: Scalars['Date'];
  updatedById?: Maybe<Scalars['ID']>;
  userIdLaborum?: Maybe<Scalars['ID']>;
  video?: Maybe<Scalars['String']>;
  websites: Array<Websites>;
  yearsOfExperience?: Maybe<Scalars['Float']>;
};


export type ProfileIsValidCvArgs = {
  jobId?: InputMaybe<Scalars['ID']>;
};

export type ProfileConfig = {
  __typename?: 'ProfileConfig';
  salaryExpectationDisabled?: Maybe<Scalars['Boolean']>;
};

export type ProfileGeolocationInput = {
  _id: Scalars['ID'];
  geolocation?: InputMaybe<GeolocationInput>;
};

export type ProfileInput = {
  _id: Scalars['ID'];
  aboutMe?: InputMaybe<Scalars['String']>;
  actualPosition?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['String']>;
  civilState?: InputMaybe<Scalars['String']>;
  competencies?: InputMaybe<Scalars['String']>;
  curriculum?: InputMaybe<CurriculumInput>;
  docNumber?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Array<InputMaybe<EducationInput>>>;
  email?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<EmailsPhonesResponseInput>>;
  especialization?: InputMaybe<Array<InputMaybe<EspecializationInput>>>;
  experience?: InputMaybe<Array<InputMaybe<ExperienceInput>>>;
  firstJob?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  idEducationLaborumDeleted?: InputMaybe<Scalars['String']>;
  idExperienceLaborumDeleted?: InputMaybe<Scalars['String']>;
  jobPosition?: InputMaybe<Scalars['String']>;
  knowledge?: InputMaybe<Array<InputMaybe<KnowledgeInput>>>;
  lastName?: InputMaybe<Scalars['String']>;
  latlon?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<EmailsPhonesResponseInput>>;
  photo?: InputMaybe<Scalars['String']>;
  salaryExpectation?: InputMaybe<SalaryExpectationInput>;
  sex?: InputMaybe<Scalars['String']>;
  socialNetworks?: InputMaybe<Array<EmailsPhonesResponseInput>>;
  status?: InputMaybe<Scalars['String']>;
  userIdLaborum?: InputMaybe<Scalars['ID']>;
  video?: InputMaybe<Scalars['String']>;
  websites?: InputMaybe<Array<EmailsPhonesResponseInput>>;
};

export type ProfileJob = {
  __typename?: 'ProfileJob';
  basicEdition?: Maybe<Array<Maybe<BasicEdition>>>;
  competencies?: Maybe<Array<Maybe<Competence>>>;
  functions?: Maybe<Array<Maybe<Scalars['String']>>>;
  knowledge?: Maybe<Array<Maybe<Scalars['String']>>>;
  languages?: Maybe<Array<Maybe<Language>>>;
  layTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  skill?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type ProfileLog = {
  __typename?: 'ProfileLog';
  _id?: Maybe<Scalars['ID']>;
  candidateId?: Maybe<Scalars['ID']>;
  lastJobId?: Maybe<Scalars['ID']>;
  logDetail?: Maybe<Scalars['JSON']>;
  profileId: Scalars['ID'];
  userId: Scalars['ID'];
  userType?: Maybe<Scalars['String']>;
};

export enum ProfileStatus {
  Draft = 'draft',
  LoadingCv = 'loadingCV',
  None = 'none',
  Scraping = 'scraping'
}

export type Publication = {
  __typename?: 'Publication';
  _id: Scalars['ID'];
  area?: Maybe<Scalars['String']>;
  availabilityToTravel?: Maybe<Scalars['Boolean']>;
  benefitsOfWork?: Maybe<Array<Maybe<Benefit>>>;
  careers?: Maybe<Array<Maybe<Scalars['String']>>>;
  confidentialCompany?: Maybe<Scalars['Boolean']>;
  contractType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disability?: Maybe<Disability>;
  educationLevel?: Maybe<Education>;
  experience?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['Date']>;
  firstPublicationDate?: Maybe<Scalars['Date']>;
  hierarchy?: Maybe<Scalars['String']>;
  journeyType?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  profile?: Maybe<ProfileJob>;
  publishday?: Maybe<Scalars['Date']>;
  salary?: Maybe<Salary>;
  status?: Maybe<PublicationStatus>;
  title?: Maybe<Scalars['String']>;
  typeOfContract?: Maybe<Scalars['String']>;
  vacancies?: Maybe<Scalars['Int']>;
  validity?: Maybe<Scalars['String']>;
};

export enum PublicationStatus {
  Closed = 'closed',
  Draft = 'draft',
  Filed = 'filed',
  Pending = 'pending',
  Published = 'published'
}

export type Query = {
  __typename?: 'Query';
  authorization: Response;
  getAllBranchOfficesByJobId: BranchOfficePagination;
  getAppSections: Array<Section>;
  getApplyJob: Job;
  getAreas: Array<Area>;
  getBranchOfficesByJobId: BranchOfficePagination;
  getCandidate: Candidate;
  getCandidateByEmailExact?: Maybe<Candidate>;
  getCandidateById: Candidate;
  getCandidateTask: CandidateTask;
  getCandidateTaskByTaskAndUser?: Maybe<CandidateTask>;
  getCandidateTasksByTask: Array<CandidateTask>;
  getCareer?: Maybe<Career>;
  getCitiesByRegionName: Array<Scalars['String']>;
  getCountries: Array<Countries>;
  getCountryCode?: Maybe<KrowdyGeoCountryCode>;
  getCurrencies: Array<Currencies>;
  getDistrictsByCityName: Array<Scalars['String']>;
  getFlowPostulationByProfileId: FlowPostulationCandidate;
  getGroupOnetSuggestions: Array<Maybe<GroupOnetSuggestion>>;
  getJob: Job;
  getJobOnetSuggestions: Array<Maybe<FindOnetSuggestion>>;
  getLaborExchangeBySlug?: Maybe<LaborExchange>;
  getLaborExchangeTemplate?: Maybe<LaborExchangeTemplate>;
  getLocationJobByCoordinates: JobLocation;
  getLocations: Array<LocationGeolocation>;
  getProfileDateOnetExpired?: Maybe<DateOnetExpired>;
  getProfileExhaustive: Profile;
  getRegionsByCountryCode: Array<Scalars['String']>;
  getSimilarJobs: Array<JobSimilar>;
  getStorageToken: TokenObject;
  getTaskById: Task;
  getTheme?: Maybe<Theme>;
  getUser?: Maybe<User>;
  holaMundo?: Maybe<Scalars['String']>;
  massiveColumnMatched: Array<Scalars['String']>;
  massiveFindDuplicatedCandidates: MassiveFindDuplicatedCandidatesResponse;
  verifyKey: SuccessResponse;
};


export type QueryGetAllBranchOfficesByJobIdArgs = {
  excludeBranchOfficeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  jobId: Scalars['ID'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  profileId?: InputMaybe<Scalars['ID']>;
  search: Scalars['String'];
};


export type QueryGetAppSectionsArgs = {
  candidateTaskId: Scalars['ID'];
  taskId: Scalars['ID'];
};


export type QueryGetApplyJobArgs = {
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
};


export type QueryGetAreasArgs = {
  input?: InputMaybe<PaginationInput>;
};


export type QueryGetBranchOfficesByJobIdArgs = {
  jobId: Scalars['ID'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  profileId?: InputMaybe<Scalars['ID']>;
  search: Scalars['String'];
};


export type QueryGetCandidateArgs = {
  jobId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  sourceApply?: InputMaybe<Scalars['String']>;
  trackingCandidateId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCandidateByEmailExactArgs = {
  email: Scalars['String'];
  jobId: Scalars['ID'];
};


export type QueryGetCandidateByIdArgs = {
  candidateId: Scalars['ID'];
};


export type QueryGetCandidateTaskArgs = {
  candidateTaskId: Scalars['ID'];
};


export type QueryGetCandidateTaskByTaskAndUserArgs = {
  taskId: Scalars['ID'];
};


export type QueryGetCandidateTasksByTaskArgs = {
  taskId: Scalars['ID'];
};


export type QueryGetCitiesByRegionNameArgs = {
  countryCode: Scalars['String'];
  regionName: Scalars['String'];
};


export type QueryGetCountryCodeArgs = {
  ip: Scalars['String'];
};


export type QueryGetDistrictsByCityNameArgs = {
  cityName: Scalars['String'];
  countryCode: Scalars['String'];
};


export type QueryGetFlowPostulationByProfileIdArgs = {
  profileId: Scalars['ID'];
};


export type QueryGetGroupOnetSuggestionsArgs = {
  textSearch?: InputMaybe<Scalars['String']>;
};


export type QueryGetJobArgs = {
  jobId: Scalars['ID'];
  publicationIndex: Scalars['Int'];
};


export type QueryGetJobOnetSuggestionsArgs = {
  textSearch?: InputMaybe<Scalars['String']>;
};


export type QueryGetLaborExchangeBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryGetLaborExchangeTemplateArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryGetLocationJobByCoordinatesArgs = {
  jobId: Scalars['ID'];
  lat: Scalars['String'];
  lng: Scalars['String'];
};


export type QueryGetLocationsArgs = {
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetProfileDateOnetExpiredArgs = {
  profileId: Scalars['ID'];
};


export type QueryGetProfileExhaustiveArgs = {
  jobId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetRegionsByCountryCodeArgs = {
  countryCode: Scalars['String'];
};


export type QueryGetSimilarJobsArgs = {
  jobId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryGetStorageTokenArgs = {
  assetType: AssetType;
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  generalFlow?: InputMaybe<GeneralFlow>;
  routeId: Scalars['String'];
  subFlow?: InputMaybe<Scalars['String']>;
};


export type QueryGetTaskByIdArgs = {
  taskId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetThemeArgs = {
  jobId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryHolaMundoArgs = {
  name: Scalars['String'];
};


export type QueryMassiveColumnMatchedArgs = {
  urlFile: Scalars['String'];
};


export type QueryMassiveFindDuplicatedCandidatesArgs = {
  columns: Scalars['JSON'];
  jobId: Scalars['ID'];
  url: Scalars['String'];
};


export type QueryVerifyKeyArgs = {
  responsableKey: Scalars['String'];
  taskId: Scalars['ID'];
};

export type Referent = {
  __typename?: 'Referent';
  _id: Scalars['ID'];
  brandingCompany?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ReferentInput = {
  brandingCompany?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type Referents = {
  __typename?: 'Referents';
  _id: Scalars['ID'];
  companyName?: Maybe<Scalars['String']>;
  experienceId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};

export type ReferredInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  docNumber?: InputMaybe<Scalars['String']>;
  docType?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type Response = {
  __typename?: 'Response';
  data?: Maybe<Scalars['JSON']>;
  success: Scalars['Boolean'];
};

export type Salary = {
  __typename?: 'Salary';
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
  typeOfMoney?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type SalaryExpectation = {
  __typename?: 'SalaryExpectation';
  _id?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  countryCode?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type SalaryExpectationInput = {
  _id?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Float']>;
  countryCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
};

export type Section = {
  __typename?: 'Section';
  completed?: Maybe<Scalars['Boolean']>;
  hiddenWhileCurrentSectionIsIncomplete?: Maybe<Scalars['Boolean']>;
  isWildCard?: Maybe<Scalars['Boolean']>;
  needValidBeforeToRender?: Maybe<Scalars['Boolean']>;
  requireAlert?: Maybe<Scalars['Boolean']>;
  sectionCode?: Maybe<SectionCode>;
  submitButtonLabel?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
  validAlertMessage?: Maybe<Scalars['String']>;
};

export enum SectionCode {
  AdditionalInformation = 'additionalInformation',
  BasicInformation = 'basicInformation',
  BasicInformationAdvanced = 'basicInformationAdvanced',
  BranchOffices = 'branchOffices',
  CandidateProfile = 'candidateProfile',
  Career = 'career',
  CareerConfirm = 'careerConfirm',
  Cv = 'cv',
  CvNotFound = 'cvNotFound',
  Experiences = 'experiences',
  ExperiencesAdvanced = 'experiencesAdvanced',
  External = 'external',
  GeneralInformation = 'generalInformation',
  LinkedinProfile = 'linkedinProfile',
  None = 'none',
  Preview = 'preview',
  Referents = 'referents',
  Residence = 'residence',
  SalaryExpectation = 'salaryExpectation',
  Studies = 'studies',
  UpdateAdvice = 'updateAdvice',
  YearsOfExperience = 'yearsOfExperience'
}

export type SimilarOnets = {
  __typename?: 'SimilarOnets';
  jobPosition?: Maybe<Scalars['String']>;
  onetCode?: Maybe<Scalars['String']>;
  principalCluster?: Maybe<Scalars['String']>;
};

export type SocialNetwork = {
  __typename?: 'SocialNetwork';
  _id: Scalars['ID'];
  socialNetwork?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SocialNetworkInput = {
  socialNetwork?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Stage = {
  __typename?: 'Stage';
  _id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  tasks: Array<Task>;
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type SuccessType = {
  __typename?: 'SuccessType';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SuccessTypeResult = {
  __typename?: 'SuccessTypeResult';
  finished?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Task = {
  __typename?: 'Task';
  _id: Scalars['ID'];
  alias?: Maybe<Scalars['String']>;
  categoryTask: CategoryTask;
  contentTask?: Maybe<ContentTask>;
  introductionHTML?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  stageId?: Maybe<Scalars['ID']>;
  taskConfig?: Maybe<TaskConfig>;
};

export type TaskConfig = {
  __typename?: 'TaskConfig';
  _id: Scalars['ID'];
  krowderGroups: Array<KrowderGroup>;
};

export type TemplateEmailsParams = {
  __typename?: 'TemplateEmailsParams';
  candidateHelpText?: Maybe<Scalars['String']>;
  srcImage?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  textBody?: Maybe<Scalars['String']>;
  textButton?: Maybe<Scalars['String']>;
  textHeader?: Maybe<Scalars['String']>;
  withImage?: Maybe<Scalars['Boolean']>;
};

export type Theme = {
  __typename?: 'Theme';
  cssTextFamily?: Maybe<Scalars['String']>;
  overrides?: Maybe<Overrides>;
  palette: ThemePalette;
  template?: Maybe<LaborExchangeTemplate>;
  typography?: Maybe<ThemeTypography>;
};

export type ThemePalette = {
  __typename?: 'ThemePalette';
  background?: Maybe<ThemePaletteConfig>;
  custom?: Maybe<ThemePaletteConfig>;
  primary: ThemePaletteConfig;
  secondary: ThemePaletteConfig;
  text?: Maybe<ThemePaletteConfig>;
};

export type ThemePaletteConfig = {
  __typename?: 'ThemePaletteConfig';
  default?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['String']>;
  secondary?: Maybe<Scalars['String']>;
  tertiary?: Maybe<Scalars['String']>;
};

export type ThemeTypography = {
  __typename?: 'ThemeTypography';
  fontFamily: Scalars['String'];
};

export type TimezoneType = {
  __typename?: 'TimezoneType';
  candidate?: Maybe<Scalars['String']>;
  responsable?: Maybe<Scalars['String']>;
};

export type TokenObject = {
  __typename?: 'TokenObject';
  acl: Scalars['String'];
  contentType: Scalars['String'];
  fileName: Scalars['String'];
  key: Scalars['String'];
  originalFileName: Scalars['String'];
  token: Scalars['String'];
  url: Scalars['String'];
};

export enum TypeCustomMessage {
  Canceled = 'Canceled',
  Confirm = 'Confirm',
  ReSchedule = 'ReSchedule',
  Schedule = 'Schedule',
  ToJoin = 'ToJoin',
  ToStart = 'ToStart'
}

export enum TypeFlowPostulationCandidate {
  HasUpdatedProfile = 'hasUpdatedProfile',
  MassApplication = 'massApplication',
  New = 'new',
  None = 'none',
  WithoutLocation = 'withoutLocation',
  WithoutLocationOrWithoutUpdatedProfile = 'withoutLocationOrWithoutUpdatedProfile'
}

export type Ubigeo = {
  __typename?: 'Ubigeo';
  _id: Scalars['ID'];
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  name?: Maybe<Scalars['String']>;
  parentCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

export type UpdateBasicCandidateTaskInput = {
  isIntroductionViewed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCvInput = {
  fileName?: InputMaybe<Scalars['String']>;
  filenameOriginal?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateCandidateInfoInput = {
  age?: InputMaybe<Scalars['Int']>;
  docNumber?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateFirstTimeInInput = {
  candidateTaskId?: InputMaybe<Scalars['String']>;
  firstTimeIn?: InputMaybe<Scalars['String']>;
};

export type UpdateProfileBasicInformationInput = {
  birthDate?: InputMaybe<Scalars['Date']>;
  docNumber?: InputMaybe<Scalars['String']>;
  docType?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<EmailsPhonesResponseInput>>;
  firstJob?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  geolocation?: InputMaybe<GeolocationInput>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<EmailsPhonesResponseInput>>;
  photo?: InputMaybe<Scalars['String']>;
  salaryExpectation?: InputMaybe<SalaryExpectationInput>;
  sex?: InputMaybe<Scalars['String']>;
  yearsOfExperience?: InputMaybe<Scalars['Float']>;
};

export type UpdateProfileCoordinatesResponse = {
  __typename?: 'UpdateProfileCoordinatesResponse';
  candidate?: Maybe<Candidate>;
  profile: Profile;
};

export type UpdateTaskDateInput = {
  candidateTaskId?: InputMaybe<Scalars['String']>;
  taskDate?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
};

export enum UserType {
  Candidate = 'candidate',
  Krowder = 'krowder',
  Recruiter = 'recruiter'
}

export type UtmInput = {
  campaign?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  medium?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};

export type Websites = {
  __typename?: 'Websites';
  _id: Scalars['ID'];
  origin?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type WebsitesInput = {
  _id: Scalars['ID'];
  origin?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};
